<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Monitoramento de viagens</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Home',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Viagens',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-btn v-if="$check(['trips.update'])" outlined type="button"
                            :color="cancellationRequests.pendingCount ? 'error' : 'primary'" elevation="0"
                            @click="openCancellationRequests">
                            <v-icon left small>mdi-car-brake-alert</v-icon>
                            Cancelamentos
                            <v-chip v-if="cancellationRequests.pendingCount" class="ml-2" x-small color="error" dark>
                                {{ cancellationRequests.pendingCount }}
                            </v-chip>
                        </v-btn>

                        <v-btn v-if="$check(['trips.export'])" id="btnNew" outlined type="button" color="primary"
                            elevation="0" target="_blank" @click="reportManageTrip()">Exportar</v-btn>

                        <v-btn v-if="$check(['logistics.view'])" id="btnNew" outlined type="button" color="primary"
                            elevation="0" target="_blank" to="/logistica">Logística</v-btn>

                        <v-btn v-if="$check(['trips.create'])" id="btnNew" type="button" color="primary" elevation="0"
                            @click="createOrUpdateTrip()">Criar
                            Viagem</v-btn>

                        <v-btn v-if="$check(['trips.status.bulk'])" outlined type="button" color="primary"
                            elevation="0" @click="bulkStatusOpen = true">
                            <v-icon left small>mdi-swap-horizontal</v-icon>
                            Trocar status
                        </v-btn>

                        <v-btn v-if="$check(['trips.update'])" outlined type="button" color="orange darken-2"
                            elevation="0" @click="openRecalculateDialog()">
                            <v-icon left small>mdi-calculator-variant</v-icon>
                            Recalcular
                        </v-btn>

                    </div>
                </div>
            </v-col>
        </v-row>

        <v-alert v-if="$check(['trips.update']) && cancellationRequests.pendingCount" class="mt-4" type="warning"
            prominent outlined border="left">
            <v-row align="center">
                <v-col class="grow">
                    Existem <strong>{{ cancellationRequests.pendingCount }}</strong>
                    {{ cancellationRequests.pendingCount === 1 ? 'solicitação de cancelamento aguardando' : 'solicitações de cancelamento aguardando' }} análise.
                </v-col>
                <v-col class="shrink">
                    <v-btn color="warning" dark @click="openCancellationRequests">Analisar agora</v-btn>
                </v-col>
            </v-row>
        </v-alert>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="osNumber" label="N. OS" v-model="dataList.filter.id"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col>
                                    <v-select no-data-text="Nenhum motorista encontrado" dense :items="dataset.drivers"
                                        label="Motorista" v-model="dataList.filter.driver_id" item-value="id"
                                        item-text="name" outlined hide-details="auto" clearable>
                                    </v-select>
                                </v-col>

                                <v-col>
                                    <v-select no-data-text="Nenhum tipo encontrado" dense
                                        :items="[{ text: 'Todos', value: null }, ...tripTypes]" label="Tipo"
                                        v-model="dataList.filter.type" item-value="value" item-text="text" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>

                            <v-row>

                                <v-col cols="4">
                                    <v-select dense :items="[{ id: '', name: 'Todos' }, ...dataset.serviceTypes]"
                                        label="Status" v-model="dataList.filter.status" item-value="id" item-text="name"
                                        outlined hide-details="auto">
                                    </v-select>
                                </v-col>

                                <v-col cols="4">
                                    <v-text-field dense id="date" label="Data" v-model="dataList.filter.date"
                                        hide-details outlined type="date"></v-text-field>

                                </v-col>
                                <v-col cols="4">
                                    <v-text-field dense id="date" label="Hora" v-model="dataList.filter.time"
                                        hide-details outlined type="time"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>

                                <v-col cols="4">
                                    <v-autocomplete dense :items="filterCustomers" label="Empresa"
                                        v-model="dataList.filter.customer" item-value="id" item-text="name" outlined
                                        hide-details="auto" :loading="filterCustomerLoading"
                                        :search-input.sync="searchFilterCustomer" cache-items
                                        :filter="item => isInResults(filterCustomers, item)"
                                        no-data-text="Nenhuma empresa encontrada" clearable>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="4">
                                    <v-text-field dense id="passenger" label="Passageiro"
                                        v-model="dataList.filter.passenger" hide-details outlined></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                    <v-text-field dense id="itinerary" label="Itinerário"
                                        placeholder="Cidade, empresa ou parada (ex.: Canoas X Videolar)"
                                        v-model="dataList.filter.itinerary" hide-details outlined></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2"
                                        :loading="dataList.loading">Aplicar filtros</v-btn>
                                    <v-btn class="ml-4" id="btnFilter" @click="clearFilters" color="primary" outlined
                                        :disabled="dataList.loading">Limpar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="mt-8" v-if="$check(['trips.view'])">
            <v-col cols="12">
                <v-card class="list-container-card">
                    <v-row
                        class="font-weight-bold text-uppercase py-1 px-4 align-center d-flex flex-nowrap text-center table-header-row">
                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 service-col-icon"></v-col>
                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 header-col-os">N. OS</v-col>
                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 header-col-datetime">Data/Hora</v-col>
                        <v-col cols="auto" class="flex-grow-1 flex-shrink-1 header-col-itinerary">Itinerário</v-col>
                        <!-- <v-col cols="auto" class="flex-grow-1 flex-shrink-1 header-col-requester">Solicitante</v-col> -->
                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 header-col-requester">Solicitantes</v-col>
                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 header-col-vehicle">Veículo</v-col>
                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 header-col-status">Status</v-col>
                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 header-col-actions">Ações</v-col>
                    </v-row>

                    <v-row v-if="dataList.loading">
                        <v-col cols="12" class="text-center py-5">
                            <v-progress-linear indeterminate color="primary" class="mb-2"></v-progress-linear>
                            <p class="mt-2">Carregando dados...</p>
                        </v-col>
                    </v-row>
                    <v-row v-else-if="dataList.data.length === 0">
                        <v-col cols="12" class="text-center py-5">
                            <p>Nenhum serviço encontrado.</p>
                        </v-col>
                    </v-row>
                    <v-row v-for="item in dataList.data" :key="item.id">
                        <v-col cols="12">
                            <v-card class="elevation-1">
                                <v-card-text class="py-2" :class="{ 'border-error': canViewTripAmounts && verifyErrorTrip(item) }">
                                    <v-row align="center" no-gutters class="d-flex flex-nowrap service-row text-center">
                                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 service-col-icon">
                                            <v-icon class="mr-1 expansion-toggle-icon"
                                                @click.stop="togglePassengerExpansion(item)">
                                                <template v-if="item.showDetailsExpansion">
                                                    mdi-chevron-up
                                                </template>
                                                <template v-else>
                                                    mdi-chevron-down
                                                </template>
                                            </v-icon>
                                        </v-col>
                                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 service-col-os">
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-icon v-if="canViewTripAmounts && verifyErrorTrip(item)" v-on="on" color="red"
                                                        class="ml-2" small>
                                                        mdi-alert
                                                    </v-icon>

                                                    <v-icon v-if="hasPendingCancellation(item)" v-on="on" color="orange darken-2"
                                                        class="ml-1" small @click.stop="openCancellationRequests"
                                                        title="Cancelamento solicitado">
                                                        mdi-car-brake-alert
                                                    </v-icon>

                                                    <a class="os-link" title="Abrir gestão da OS"
                                                        @click.stop="openTripManager(item)">#{{ item.id }}</a>
                                                </template>
                                                <span v-if="canViewTripAmounts && verifyErrorTrip(item)">{{ verifyErrorTrip(item) }}</span>
                                            </v-tooltip>
                                        </v-col>
                                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 service-col-datetime">
                                            <span class="d-xs-block d-sm-none font-weight-bold">Data/Hora: </span>{{
                                                $moment(item.date).format('DD/MM/YYYY') }}
                                            <br> {{ $moment(item.time, 'HH:mm:ss').format('HH:mm') }}
                                        </v-col>
                                        <v-col cols="auto" class="flex-grow-1 flex-shrink-1 service-col-itinerary">
                                            <span class="d-xs-block d-sm-none font-weight-bold">Itinerário: </span>
                                            <RouteItinerary :itinerary="item.route_itinerary" :fallback="item.itinerary" />
                                        </v-col>
                                        <!-- <v-col cols="auto" class="flex-grow-1 flex-shrink-1 service-col-requester">
                                            <span class="d-xs-block d-sm-none font-weight-bold">Solicitante: </span>{{
                                                truncateText(item.requester ?
                                                    item.requester.name : 'N/A') }}
                                        </v-col> -->
                                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 service-col-driver">
                                            <span class="d-xs-block d-sm-none font-weight-bold">Solicitantes: </span>{{
                                                normalizeRequesters(item) }}
                                        </v-col>
                                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 service-col-vehicle">
                                            <span class="d-xs-block d-sm-none font-weight-bold">Veículo: </span>
                                            <div v-if="item.vehicle" class="text-uppercase">
                                                <v-avatar v-if="item.vehicle.image_id" :size="40">
                                                    <private-image :id="item.vehicle.image_id" alt="Imagem do veículo"
                                                        :size="35" />
                                                </v-avatar>

                                                {{ item.vehicle.plate }}
                                            </div>
                                            <div v-else>
                                                <v-icon color="grey lighten-1">mdi-car-off</v-icon>
                                            </div>
                                        </v-col>
                                        <v-col cols="auto" class="flex-grow-0 flex-shrink-0 service-col-status">
                                            <span class="d-xs-block d-sm-none font-weight-bold">Status: </span>
                                            <v-chip :color="getStatusColor(item.status)" dark small>
                                                {{ statusMap[item.status] || 'Desconhecido' }}
                                            </v-chip>
                                        </v-col>
                                        <v-col cols="auto"
                                            class="flex-grow-0 flex-shrink-0 flex align-center pr-1 service-col-actions">
                                            <span class="d-xs-block d-sm-none font-weight-bold mr-2">Ações: </span>
                                            <v-icon small class="mr-1" color="primary" @click="openTripManager(item)"
                                                title="Gestão da OS (rota, paradas e passageiros)">
                                                mdi-clipboard-edit-outline
                                            </v-icon>
                                            <v-icon small class="mr-1" @click="createOrUpdateTrip(item)" title="Editar">
                                                mdi-pencil-outline
                                            </v-icon>
                                            <v-icon small class="mr-1" @click="openModal(item)" title="Ver Detalhes">
                                                mdi-eye-outline
                                            </v-icon>
                                            <v-icon small class="mr-1" @click="addDriverToService(item)"
                                                title="Adicionar Motorista">
                                                mdi-car-outline
                                            </v-icon>
                                            <v-icon small class="mr-1" @click="addPassengerToService(item)"
                                                title="Adicionar Passageiro">
                                                mdi-account-plus-outline
                                            </v-icon>
                                            <v-icon small class="mr-1" @click="openCloneDialog(item)"
                                                title="Clonar OS">
                                                mdi-content-duplicate
                                            </v-icon>
                                            <v-icon v-if="canEditTripStops(item)" small class="mr-1"
                                                @click="openStopsDialog(item)" title="Pontos de parada">
                                                mdi-map-marker-path
                                            </v-icon>
                                            <v-icon small @click="confirmDeleteTrip(item)" title="Excluir">
                                                mdi-delete-outline
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                    <v-divider class="my-2"></v-divider>
                                    <v-expansion-panels flat multiple :value="item.showDetailsExpansion ? [0] : []"
                                        class="mt-2">
                                        <v-expansion-panel>
                                            <v-expansion-panel-header hide-actions class="non-clickable-header">
                                                <div class="d-flex align-center">
                                                    <span class="font-weight-bold mr-2">Passageiros:</span>
                                                    <v-icon class="mr-2" small
                                                        :color="item.passengers && item.passengers.length > 0 ? getStatusColor(item.status) : 'grey'">mdi-circle</v-icon>
                                                    <span>{{ item.passengers && item.passengers.length > 0 ?
                                                        `${item.passengers.length} passageiro(s)` :
                                                        'Nenhum passageiro' }}</span>
                                                    <v-chip v-if="item.stops && item.stops.length" x-small outlined
                                                        color="orange darken-2" class="ml-2"
                                                        :title="item.stops.map(stop => `${stop.position}. ${stop.address}`).join('\n')"
                                                        @click.stop="openStopsDialog(item)">
                                                        <v-icon x-small left>mdi-map-marker-path</v-icon>
                                                        {{ item.stops.length }} parada(s)
                                                    </v-chip>

                                                    <v-spacer></v-spacer>

                                                    <div class="d-flex align-center flex-wrap ml-2">
                                                        <span class="mr-2"><strong>Tipo:</strong> {{ item.type |
                                                            enum(tripTypes, 'value', 'text') }}</span>
                                                        <span class="mr-2"><strong>Obs:</strong> {{ item.obs || 'N/A'
                                                            }}</span>
                                                        <span class="mr-2"><strong>Motorista:</strong> {{ item.driver ?
                                                            truncateText(item.driver.nickname || item.driver.name) :
                                                            'N/A' }}
                                                        </span>
                                                        <span><strong>Frota:</strong> {{ item.vehicle ?
                                                            (item.vehicle.code
                                                                || item.vehicle.plate) : 'N/A' }}</span>
                                                    </div>

                                                </div>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <div>
                                                    <div class="d-flex align-center">
                                                        <span class="font-weight-bold mr-2">Detalhes da Corrida</span>
                                                        <v-icon :color="getStatusColor(item.status)" size="medium"
                                                            class="ml-1">
                                                            mdi-circle
                                                        </v-icon>
                                                    </div>

                                                    <div class="d-flex align-center">
                                                        <span class="mr-2 mt-4">
                                                            <strong>Motorista:</strong>
                                                            {{ item.driver ? item.driver.name : 'N/A' }}
                                                            <br>
                                                            <strong>Veículo:</strong>
                                                            {{ item.vehicle ? item.vehicle.model.model + ' - ' +
                                                                item.vehicle.plate : 'N/A' }}
                                                            <br>
                                                            <template v-if="canViewTripAmounts">
                                                                <strong>Valor:</strong>
                                                                <template v-if="item.value">
                                                                    R$ {{ item.value | currency }}
                                                                </template>
                                                                <template v-else>
                                                                    N/A
                                                                </template>
                                                                <br>
                                                            </template>
                                                        </span>
                                                    </div>

                                                    <div class="mt-4">
                                                        <h4>Detalhes Passageiros:</h4>
                                                        <template v-if="item.passengers.length > 0">
                                                            <v-timeline
                                                                v-for="(itemPassenger, index) in item.passengers"
                                                                :key="index" dense>
                                                                <v-timeline-item :key="`passenger-${itemPassenger.id}`"
                                                                    :color="dataset.tripPassengerStatus.find((x) => x.id == itemPassenger.status).color"
                                                                    small class="timeline-item-no-line-above-first">
                                                                    <div class="d-flex align-center">
                                                                        <span class="mr-2 font-weight-medium">
                                                                            {{ itemPassenger.time | shortTime }}
                                                                        </span>
                                                                        <span class="font-weight-medium">
                                                                            {{ itemPassenger.passenger.name }}
                                                                            <strong>({{ itemPassenger.status |
                                                                                enum(dataset.tripPassengerStatus, 'id',
                                                                                'name') }})</strong>
                                                                        </span>
                                                                    </div>
                                                                    <div class="text-caption">
                                                                        <strong>Contato:</strong>
                                                                        <span>
                                                                            {{
                                                                                itemPassenger.passenger.phone_number ||
                                                                                'N/A'
                                                                            }}
                                                                        </span>
                                                                        <br>
                                                                        <strong>Centro de Custo:</strong>
                                                                        <span v-if="itemPassenger.cost_center">
                                                                            {{
                                                                                itemPassenger.cost_center.name ||
                                                                                itemPassenger.cost_center.code
                                                                            }}
                                                                        </span>
                                                                        <span v-else>N/A</span>
                                                                        <br>
                                                                        <strong>Solicitante:</strong>
                                                                        <span>
                                                                            {{
                                                                                itemPassenger.requester ?
                                                                                    itemPassenger.requester.name :
                                                                                    'N/A'
                                                                            }}
                                                                        </span>
                                                                        <br>
                                                                        <br>
                                                                        <strong>De:</strong> {{
                                                                            itemPassenger.points[0].address ||
                                                                            'Endereço não informado' }}
                                                                        <br>
                                                                        <strong>Para:</strong> {{
                                                                            itemPassenger.points[1].address ||
                                                                            'Endereço não informado' }}
                                                                        <br>
                                                                        <strong>Distância:</strong>
                                                                        <span v-if="itemPassenger.distance">
                                                                            {{
                                                                                convertDistanceOrDuration({
                                                                                    distance:
                                                                                        itemPassenger.distance
                                                                                }).distance
                                                                            }} km
                                                                        </span>
                                                                        <span v-else>N/A</span>
                                                                        <br>
                                                                        <strong>Duração:</strong>
                                                                        <span v-if="itemPassenger.duration">
                                                                            {{
                                                                                convertDistanceOrDuration({
                                                                                    duration:
                                                                                        itemPassenger.duration
                                                                                }).duration
                                                                            }}
                                                                        </span>
                                                                        <span v-else>N/A</span>
                                                                        <br>
                                                                        <strong v-if="canViewTripAmounts">Valor:</strong>
                                                                        <span v-if="canViewTripAmounts">
                                                                            R$
                                                                            {{
                                                                                (itemPassenger.value || 0) | currency
                                                                            }}
                                                                            <v-chip v-if="itemPassenger.manual_value"
                                                                                x-small color="warning" outlined
                                                                                class="ml-1">manual</v-chip>
                                                                        </span>
                                                                        <br>
                                                                        <br>
                                                                        <strong>OBS:</strong>
                                                                        <span>
                                                                            {{
                                                                                itemPassenger.observation || 'N/A'
                                                                            }}
                                                                        </span>
                                                                    </div>
                                                                    <div class="mt-6">
                                                                        <v-btn type="button" elevation="0" class="mr-4"
                                                                            color="primary-200"
                                                                            @click="editPassenger(item, itemPassenger)"
                                                                            small>
                                                                            <v-icon class="mr-2" size="large">
                                                                                mdi-pencil-outline
                                                                            </v-icon>
                                                                            editar</v-btn>
                                                                        <v-btn type="button" elevation="0" color="error"
                                                                            @click="removePassenger(item, itemPassenger)"
                                                                            small>
                                                                            <v-icon class="mr-2" size="large">
                                                                                mdi-delete-outline
                                                                            </v-icon>
                                                                            remover</v-btn>
                                                                    </div>
                                                                </v-timeline-item>

                                                            </v-timeline>
                                                        </template>

                                                        <div v-else>
                                                            <span class="text-subtitle-1 grey--text text-left">Nenhum
                                                                passageiro associado a esta corrida.
                                                            </span>
                                                        </div>
                                                    </div>


                                                    <br>
                                                    <v-divider></v-divider>
                                                    <br>
                                                    <div>
                                                        <v-btn icon small @click="openMapModal(item)">
                                                            <v-icon left>mdi-map-marker-path</v-icon>
                                                        </v-btn>
                                                        <!-- <v-btn class="ml-2" icon small>
                                                            <v-icon left>mdi-check-circle-outline</v-icon>
                                                        </v-btn>

                                                        <v-btn class="ml-2" icon small>
                                                            <v-icon left>mdi-close-circle-outline</v-icon>
                                                        </v-btn> -->

                                                    </div>

                                                </div>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <divider></divider>

                    <v-row v-if="dataList.data.length > 0" class="mt-8">
                        <v-col cols="12" class="d-flex align-center justify-end">
                            <div class="d-flex align-center mr-4">
                                <span class="text-caption mr-2">Itens por página:</span>
                                <v-select :items="dataList.footerOptions.itemsPerPageOptions"
                                    v-model="dataList.options.size" @change="pageSizeChanged" dense outlined
                                    hide-details style="max-width: 100px;" class="text-caption mr-4"></v-select>
                            </div>

                            <div class="text-caption mr-4">
                                {{ (dataList.options.page - 1) * dataList.options.size + 1 }} -
                                {{ Math.min(dataList.options.page * dataList.options.size, dataList.count) }} de
                                {{ dataList.count }}
                            </div>

                            <v-pagination v-model="dataList.options.page"
                                :length="Math.ceil(dataList.count / dataList.options.size)" @input="pageChanged"
                                total-visible="5">
                            </v-pagination>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-else>
            <v-col>
                <v-card>
                    <v-card-text>
                        Sem permissão para visualizar as viagens
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- MODAL VISUALIZAR ROTAS -->
        <v-dialog v-model="dialogMap" max-width="800px" @shown="onMapModalShown">
            <v-card>
                <v-card-title class="custom-modal-title text-uppercase black--text font-weight-bold mb-3">
                    Rotas da Corrida
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogMap = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="mt-6">
                    <div class="map-container" style="height: 500px; width: 100%;">
                        <TripMap ref="tripMapComponent" v-if="mapServiceDetails" :trip="mapServiceDetails" />
                    </div>
                </v-card-text>
                <!-- <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogMap = false">Fechar</v-btn>
                </v-card-actions> -->
            </v-card>
        </v-dialog>

        <!-- TROCA DE STATUS EM LOTE -->
        <TripBulkStatusDialog v-model="bulkStatusOpen" @updated="load()" />

        <!-- GESTAO DA OS -->
        <TripManager ref="tripManager" v-model="tripManager.open" :trip-id="tripManager.tripId"
            :can-view-amounts="canViewTripAmounts" @updated="load()"
            @add-passenger="trip => passengerFormFromTripManager(() => addPassengerToService(trip))"
            @edit-passenger="(trip, passenger) => passengerFormFromTripManager(() => editPassengerFromManager(trip, passenger))"
            @remove-passenger="(trip, passenger) => fromTripManager(() => removePassenger(trip, passenger))" />

        <!-- MODAL PONTOS DE PARADA -->
        <v-dialog v-model="stopsDialog.open" max-width="640px" persistent>
            <v-card class="pa-3">
                <v-card-title class="custom-modal-title text-uppercase black--text font-weight-bold">
                    Pontos de parada - OS #{{ stopsDialog.trip ? stopsDialog.trip.id : '' }}
                    <v-spacer></v-spacer>
                    <v-btn icon :disabled="stopsDialog.loading" @click="stopsDialog.open = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-alert v-if="stopsDialog.trip && !tripStopsConfig(stopsDialog.trip).enabled" dense text
                        type="warning" class="mb-4">
                        Nenhuma empresa desta viagem está com pontos de parada habilitados. É possível apenas
                        remover as paradas existentes.
                    </v-alert>
                    <v-form ref="stopsFormRef">
                        <TripStopsEditor v-model="stopsDialog.stops" show-arrival
                            :max="stopsDialog.trip ? tripStopsConfig(stopsDialog.trip).max : 20"
                            :disabled="stopsDialog.loading || !stopsDialog.editable"
                            @error="message => $dialog.notify.error(message, { position: 'top-right', timeout: 4000 })" />
                    </v-form>
                    <p v-if="!stopsDialog.editable" class="text-caption mt-3 mb-0">
                        Viagem finalizada ou cancelada: as paradas não podem ser alteradas.
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text :disabled="stopsDialog.loading" @click="stopsDialog.open = false">Cancelar</v-btn>
                    <v-btn color="primary" elevation="0" :loading="stopsDialog.loading"
                        :disabled="!stopsDialog.editable" @click="saveStops">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL CRIAR VIAGEM -->
        <v-dialog v-model="dialogTrip" max-width="500px">
            <v-card class='pa-3'>
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h3 class="custom-modal-title text-uppercase black--text font-weight-bold mb-3">
                                {{ dataset.data.id ? 'Atualizar' : 'Incluir' }} Viagem
                            </h3>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-form ref="tripForm" v-model="tripFormValid" @submit.prevent="saveTrip()">
                        <v-row no-gutters>
                            <v-col>
                                <v-autocomplete dense outlined :items="dataset.vehicles" label="Veículo" class="mb-7"
                                    :loading="dataset.vehicleLoading" :search-input.sync="searchVehicle"
                                    v-model="dataset.data.vehicle_id" item-value="id" item-text="model.model"
                                    hide-details="auto" cache-items :filter="item => isInResults(dataset.vehicles, item)"
                                    no-data-text="Nenhum veículo encontrado" clearable></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col>
                                <v-autocomplete dense outlined label="Motorista" :items="dataset.drivers"
                                    :loading="dataset.driverLoading" class="mb-7" :search-input.sync="searchDriver"
                                    v-model="dataset.data.driver_id" item-value="id" item-text="name"
                                    :filter="() => true" hide-details="auto" no-data-text="Nenhum motorista encontrado"
                                    clearable></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col>
                                <v-select dense outlined v-model="dataset.data.type" :items="tripTypes"
                                    item-value="value" item-text="text" label="Tipo de Viagem"
                                    :disabled="dataset.data.passengers && dataset.data.passengers.length"
                                    :rules="[v => !!v || 'Tipo é obrigatório']" required></v-select>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col>
                                <v-select dense outlined v-model="dataset.data.status" :items="dataset.serviceTypes"
                                    item-value="id" item-text="name" label="Status"
                                    :rules="[v => !!v || 'Status é obrigatório']" required></v-select>

                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col>
                                <v-text-field dense label="Data da Viagem" v-model="dataset.data.date" outlined
                                    type="date" hide-details="auto" placeholder="DD/MM/AAAA" :rules="[
                                        v => !!v || 'Data é obrigatória'
                                    ]"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <v-text-field dense label="Hora da Viagem" v-model="dataset.data.time" outlined
                                    hide-details="auto" type="time" :rules="[
                                        v => !!v || 'Hora é obrigatória'
                                    ]"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <v-select dense outlined v-model="dataset.data.toll_id" :items="dataset.tolls"
                                    item-value="id" item-text="name" label="Pedágio" clearable></v-select>
                            </v-col>
                        </v-row>

                        <v-divider class="my-4"></v-divider>

                        <div v-if="canViewTripAmounts" class="values-section">
                            <div class="values-title">
                                <v-icon small color="primary" class="mr-1">mdi-cash-edit</v-icon>
                                Valores manuais
                            </div>
                            <p class="values-hint">
                                Deixe em branco para o sistema calcular automaticamente.
                            </p>

                            <v-row dense>
                                <v-col cols="12">
                                    <v-currency-field dense outlined clearable prefix="R$" :default-value="null"
                                        label="Pedágio manual" v-model="dataset.data.manual_toll_value"
                                        placeholder="Automático" hide-details="auto"></v-currency-field>
                                </v-col>
                            </v-row>

                            <v-row dense align="center">
                                <v-col cols="12" :sm="dataset.data.manual_value ? 6 : 12">
                                    <v-switch v-model="dataset.data.manual_value" color="primary" hide-details dense
                                        class="mt-1 mb-0" label="Definir valor total da viagem"></v-switch>
                                </v-col>
                                <v-col cols="12" sm="6" v-if="dataset.data.manual_value">
                                    <v-currency-field dense outlined prefix="R$" label="Valor total"
                                        v-model="dataset.data.value" hide-details="auto"></v-currency-field>
                                </v-col>
                            </v-row>

                            <p v-if="dataset.data.manual_value" class="values-hint mt-2 mb-0">
                                O total informado é dividido entre os passageiros da viagem.
                            </p>
                        </div>

                        <!-- <v-row no-gutters>
                            <v-col>
                                <v-select dense outlined v-model="dataset.data.holiday_id" :items="dataset.holidays"
                                    item-value="id" item-text="name" label="Feriado" clearable></v-select>
                            </v-col>
                        </v-row> -->
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :loading="dataList.loading" color="primary" @click="saveTrip()">{{ dataset.data.id ?
                        'Atualizar' :
                        'Salvar' }}</v-btn>
                    <v-btn color="grey darken-1" text @click="dialogTrip = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL DETALHES  -->
        <v-dialog v-model="dialogService" max-width="780px">
            <v-card class='pa-3'>
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h3 class="custom-modal-title text-uppercase black--text font-weight-bold">
                                Detalhes do Serviço
                            </h3>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row no-gutters>
                        <v-col>
                            <v-row>
                                <v-col>
                                    <v-row v-if="selectedItemDetails">
                                        <v-col>
                                            <br>
                                            <p>N.OS: <strong> {{ selectedItemDetails.id }}</strong></p>

                                            <p>Status: <strong> {{ statusMap[selectedItemDetails.status] || 'N/A'
                                                    }}</strong>
                                            </p>

                                            <p>Data/Hora: <strong>
                                                    {{ $moment(selectedItemDetails.date).format('DD/MM/YYYY') }}
                                                    {{ $moment(selectedItemDetails.time, 'HH:mm:ss').format('HH:mm') }}
                                                </strong></p>

                                            <p>Itinerario: <strong><RouteItinerary wrap :max="0"
                                                        :itinerary="selectedItemDetails.route_itinerary"
                                                        :fallback="selectedItemDetails.itinerary" /></strong>
                                            </p>

                                            <p>Solicitante: <strong>{{ selectedItemDetails.requester ?
                                                selectedItemDetails.requester.name : 'N/A' }}</strong>
                                            </p>

                                            <p>Veiculo: <strong>{{ selectedItemDetails.vehicle
                                                ? `${selectedItemDetails.vehicle.model.model} -
                                                    ${selectedItemDetails.vehicle.model.brand} Placa:
                                                    ${selectedItemDetails.vehicle.plate}`
                                                : 'N/A'
                                                    }}</strong></p>

                                            <p>Motorista: <strong>{{ selectedItemDetails.driver ?
                                                (selectedItemDetails.driver.nickname ||
                                                    selectedItemDetails.driver.name) :
                                                    'N/A' }}</strong></p>

                                            <p>Tipo de viagem: <strong>{{ selectedItemDetails.type | enum(tripTypes,
                                                'value',
                                                    'text') }}</strong>
                                            </p>

                                            <p>Informação adicional: <strong>{{
                                                selectedItemDetails.additional_information ||
                                                    'N/A' }}</strong></p>

                                            <p v-if="canViewTripAmounts">Valor: <strong>
                                                    <template v-if="selectedItemDetails.value">
                                                        R$ {{ selectedItemDetails.value | currency }}
                                                    </template>
                                                    <template v-else>
                                                        N/A
                                                    </template>
                                                </strong>
                                            </p>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <template v-if="selectedItemDetails && selectedItemDetails.stops && selectedItemDetails.stops.length">
                                <v-row>
                                    <v-col>
                                        <span class="text-left">Pontos de parada: </span>
                                    </v-col>
                                </v-row>
                                <v-list dense class="py-0 mb-4">
                                    <v-list-item v-for="stop in selectedItemDetails.stops" :key="`stop-${stop.id}`"
                                        class="px-0">
                                        <v-list-item-avatar size="24" color="orange darken-2" class="white--text caption mr-3">
                                            {{ stop.position }}
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title class="text-wrap">
                                                <strong v-if="stop.time">{{ String(stop.time).slice(0, 5) }} · </strong>{{ stop.address }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle v-if="stop.observation" class="text-wrap">
                                                {{ stop.observation }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-chip x-small :color="stop.arrived_at ? 'success' : 'grey lighten-2'"
                                                :dark="!!stop.arrived_at">
                                                {{ stop.arrived_at ? `Chegada ${formatTripHistoryDate(stop.arrived_at)}` : 'Pendente' }}
                                            </v-chip>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </template>

                            <v-row>
                                <v-col>
                                    <span class="text-left">Passageiro(s): </span>
                                </v-col>
                            </v-row>

                            <v-expansion-panels class="mt-2"
                                v-if="selectedItemDetails && selectedItemDetails.passengers && selectedItemDetails.passengers.length > 0">

                                <v-expansion-panel v-for="(itemPassenger, index) in selectedItemDetails.passengers"
                                    :key="index">
                                    <v-expansion-panel-header class='font-weight-bold'>
                                        {{ itemPassenger.passenger && itemPassenger.passenger.name ?
                                            itemPassenger.passenger.name : 'N/A' }}
                                        <v-spacer></v-spacer>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-row>
                                            <v-col>
                                                <p>Empresa: <span class="text-uppercase"><strong> {{
                                                    itemPassenger.passenger.customer.name || 'N/A'
                                                            }}</strong></span></p>
                                                <p>Hora de embarque: <strong> {{ itemPassenger.time || 'N/A'
                                                }}</strong></p>
                                                <p>Endereço origem: <strong> {{ itemPassenger.points[0].address || 'N/A'
                                                }}</strong></p>
                                                <p>Endereço destino: <strong> {{ itemPassenger.points[1].address ||
                                                    'N/A'
                                                        }}</strong></p>
                                                <p v-if="itemPassenger.reason">Motivo: <strong> {{
                                                    getReasonName(itemPassenger.passenger && itemPassenger.passenger.customer, itemPassenger.reason)
                                                        }}</strong></p>
                                                <p v-if="itemPassenger.justification">Justificativa: <strong> {{
                                                    itemPassenger.justification }}</strong></p>
                                                <p v-if="itemPassenger.observation">Observação: <strong> {{
                                                    itemPassenger.observation }}</strong></p>
                                                <!-- <p>Valor adicional: <strong>{{ itemPassenger.value |
                                                        }}</strong></p> -->
                                                <!-- <p>Centro de custo: <strong>{{ passenger.pivot.cost_center || 'N/A'
                                                        }}</strong>
                                                </p> -->
                                                <!-- <p>Valor pedágio: <strong>{{ passenger.pivot.toll_value || 'N/A'
                                                        }}</strong></p> -->
                                                <p v-if="canViewTripAmounts">Valor: <strong>R$ {{
                                                    itemPassenger.value
                                                    | currency }}</strong></p>
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>

                            <v-row v-else>
                                <v-col>
                                    <span>Nenhum passageiro encontrado</span>
                                </v-col>
                            </v-row>

                            <template v-if="canViewTripHistory">
                                <v-divider class="my-5"></v-divider>

                                <div class="trip-history-header">
                                    <div>
                                        <h4 class="mb-1">Histórico de alterações</h4>
                                        <span class="text-caption grey--text text--darken-1">
                                            Movimentações registradas na auditoria da OS.
                                        </span>
                                    </div>
                                    <v-btn icon small :loading="tripHistory.loading" @click="loadTripHistory()">
                                        <v-icon>mdi-refresh</v-icon>
                                    </v-btn>
                                </div>

                                <v-progress-linear
                                    v-if="tripHistory.loading"
                                    indeterminate
                                    color="primary"
                                    class="my-4"
                                ></v-progress-linear>

                                <v-alert
                                    v-else-if="tripHistory.error"
                                    dense
                                    text
                                    type="error"
                                    class="mt-4"
                                >
                                    Não foi possível carregar o histórico da OS.
                                </v-alert>

                                <v-alert
                                    v-else-if="!tripHistory.items.length"
                                    dense
                                    text
                                    type="info"
                                    class="mt-4"
                                >
                                    Nenhuma movimentação registrada na auditoria para esta OS.
                                </v-alert>

                                <v-timeline v-else dense class="trip-history-timeline">
                                    <v-timeline-item
                                        v-for="item in tripHistory.items"
                                        :key="item.id"
                                        :color="getTripHistoryColor(item)"
                                        :icon="getTripHistoryIcon(item)"
                                        small
                                    >
                                        <div class="trip-history-event">
                                            <div class="trip-history-event-title">
                                                <strong>{{ item.title }}</strong>
                                                <span>{{ formatTripHistoryDate(item.date) }}</span>
                                            </div>
                                            <div class="trip-history-event-description">
                                                {{ item.description }}
                                            </div>
                                            <div class="trip-history-event-meta">
                                                <v-chip x-small outlined>{{ item.module_label }}</v-chip>
                                                <v-chip x-small outlined>{{ item.actor }}</v-chip>
                                            </div>

                                            <v-expansion-panels
                                                v-if="item.changes && item.changes.length"
                                                flat
                                                accordion
                                                class="mt-2"
                                            >
                                                <v-expansion-panel>
                                                    <v-expansion-panel-header class="trip-history-details-header">
                                                        Ver detalhes
                                                    </v-expansion-panel-header>
                                                    <v-expansion-panel-content>
                                                        <v-simple-table dense class="trip-history-change-table">
                                                            <template #default>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Campo</th>
                                                                        <th>Antes</th>
                                                                        <th>Depois</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="change in item.changes" :key="change.key">
                                                                        <td class="font-weight-medium">{{ change.label }}</td>
                                                                        <td>{{ change.before }}</td>
                                                                        <td>{{ change.after }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </template>
                                                        </v-simple-table>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </div>
                                    </v-timeline-item>
                                </v-timeline>
                            </template>

                        </v-col>

                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary darken-1" text @click="dialogService = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL CLONAR OS -->
        <v-dialog v-model="dialogClone" max-width="620px" persistent>
            <v-card class="pa-3" v-if="cloneForm.trip">
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h3 class="custom-modal-title text-uppercase black--text font-weight-bold">
                                Clonar OS
                            </h3>
                        </v-col>
                    </v-row>
                </v-card-title>

                <v-card-text>
                    <v-form ref="cloneFormRef">
                        <v-alert dense text color="primary" class="mb-4">
                            Origem: <strong>#{{ cloneForm.trip.id }}</strong> —
                            {{ cloneForm.trip.date | defaultDate }} {{ cloneForm.trip.time }} —
                            {{ (cloneForm.trip.passengers || []).length }} passageiro(s)
                        </v-alert>

                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field dense outlined type="number" min="1" max="100"
                                    label="Quantidade de OS" v-model.number="cloneForm.quantity"
                                    hint="Quantas OS serão criadas" persistent-hint
                                    :rules="[v => (v >= 1 && v <= 100) || 'Informe de 1 a 100']"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select dense outlined :items="tripTypes" label="Tipo"
                                    v-model="cloneForm.type"></v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field dense outlined type="date" label="Data"
                                    v-model="cloneForm.date"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field dense outlined type="time" label="Horário"
                                    v-model="cloneForm.time"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-divider class="my-3"></v-divider>

                        <v-switch v-model="cloneForm.clonePassengers" color="primary" hide-details
                            label="Clonar passageiros" class="mt-0 mb-2"></v-switch>

                        <div v-if="cloneForm.clonePassengers">
                            <p class="caption grey--text mb-1">Desmarque quem não deve ir nas cópias</p>
                            <v-checkbox v-for="p in (cloneForm.trip.passengers || [])" :key="p.id"
                                v-model="cloneForm.passenger_ids" :value="p.id" color="primary" dense hide-details
                                class="mt-0">
                                <template v-slot:label>
                                    <span class="body-2">{{ p.passenger ? p.passenger.name : 'Passageiro' }}
                                        <span class="grey--text"> — {{ p.time }}</span></span>
                                </template>
                            </v-checkbox>
                        </div>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :loading="cloneForm.loading" @click="saveClone()">Clonar</v-btn>
                    <v-btn color="grey darken-1" text :disabled="cloneForm.loading"
                        @click="dialogClone = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL ADICIONAR MOTORISTA -->
        <v-dialog v-model="dialogAddDriver" max-width="600px">
            <v-card class='pa-3'>
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h3 class="custom-modal-title text-uppercase black--text font-weight-bold mb-5">
                                Adicionar Motorista ao Serviço
                            </h3>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-form @submit.prevent="saveAssignedDriver()">
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete dense outlined label="Motorista" :items="dataset.drivers"
                                    :loading="dataset.driverLoading" class="mb-7" :search-input.sync="searchDriver"
                                    v-model="dataset.data.driver_id" item-value="id" item-text="name"
                                    :filter="() => true" hide-details="auto"
                                    no-data-text="Nenhum motorista encontrado"></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-spacer></v-spacer>
                <v-card-actions>
                    <v-btn color="grey darken-1" text @click="dialogAddDriver = false">Cancelar</v-btn>
                    <v-btn color="primary" @click="saveAssignedDriver()">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL DE ADICIONAR NOVO PASSAGEIRO -->
        <v-dialog v-model="dialogAddPassenger" :max-width="newPassenger.passenger ? 1280 : 800">
            <v-card :class="['add-pax-modal', { 'add-pax-modal--mapa': !!newPassenger.passenger }]">
                <v-card-title>
                    <v-row justify="center">
                        <v-col cols="12">
                            <h3 class="custom-modal-title text-uppercase black--text font-weight-bold mb-3">
                                {{ newPassenger.id ? 'Atualizar' : 'Adicionar' }} Passageiro
                            </h3>
                        </v-col>
                    </v-row>
                </v-card-title>

                <div class="add-pax-modal__body">
                <!-- <v-card-text>
                    <v-row>
                        <v-col>
                            <span><strong>Itinerário: </strong></span>
                            <br>
                            <span><strong>Valor: </strong></span>
                        </v-col>
                    </v-row>
                </v-card-text> -->

                <v-card-text class="add-pax-modal__form">
                    <v-form ref="passengerForm" v-model="passengerFormValid">

                        <div :class="{ 'pax-card': newPassenger.passenger }">
                        <div v-if="newPassenger.passenger" class="pax-secao"><span>1</span>
                            <div><strong>Passageiro</strong><small>Empresa, passageiro, rateio e solicitante.</small></div>
                        </div>

                        <v-row v-if="!newPassenger.id">
                            <v-col cols="12" :md="newPassenger.passenger ? 12 : 6">
                                <v-subheader class="pl-0 font-weight-bold">Empresa</v-subheader>
                                <v-autocomplete dense outlined :items="dataset.customers" :disabled="newPassenger.id"
                                    :loading="dataset.customerLoading" :search-input.sync="searchCustomer"
                                    v-model="newPassenger.customer" item-value="id" item-text="name" return-object
                                    hide-details="auto" cache-items no-data-text="Nenhuma empresa encontrada"
                                    :filter="item => isInResults(dataset.customers, item)" :rules="[$rules.required]" required
                                    @change="changeCustomer"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" :md="newPassenger.passenger ? 12 : 6" v-if="newPassenger.customer">
                                <v-subheader class="pl-0 font-weight-bold">Passageiro</v-subheader>
                                <v-autocomplete dense outlined class="pax-nowrap" :items="dataset.passengers"
                                    :disabled="newPassenger.id"
                                    :loading="dataset.passengerLoading" :search-input.sync="searchPassenger"
                                    v-model="newPassenger.passenger" item-value="id" item-text="name" return-object
                                    hide-details="auto" :filter="() => true"
                                    :no-data-text="searchPassenger && searchPassenger.trim().length
                                        ? 'Nenhum passageiro encontrado'
                                        : 'Digite parte do nome para buscar'"
                                    hint="Digite ao menos parte do nome para pesquisar" persistent-hint
                                    :rules="[$rules.required]" @change="onPassengerSelected($event)" required>
                                    <template v-slot:item="{ item }">
                                        <span> {{ item.name }} ({{ item.registration }})</span>
                                    </template>

                                    <template v-slot:selection="{ item }">
                                        <span class="selecao-linha" :title="`${item.name} (${item.registration})`">{{
                                            item.name }} ({{ item.registration }})</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <template v-else>
                            <v-row>
                                <v-col>
                                    <v-subheader class="pl-0 font-weight-bold">Passageiro</v-subheader>
                                    <span>{{ newPassenger.passenger.name }}</span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                        </template>

                        <v-row v-if="newPassenger.passenger">
                            <v-col cols="12">
                                <v-select dense id="costCenter" :items="dataset.costCenters" label="Centro de custo"
                                    v-model="newPassenger.cost_center_id" item-value="id"
                                    :item-text="item => item.name ? item.name : item.code" required
                                    :rules="[$rules.required]" outlined hide-details="auto" />
                            </v-col>
                            <v-col cols="12">
                                <v-autocomplete dense outlined :items="dataset.requesters" label="Solicitante"
                                    :loading="dataset.requesterLoading" :search-input.sync="searchRequester"
                                    v-model="newPassenger.requester_id" item-value="id" item-text="name"
                                    hide-details="auto" cache-items :filter="item => isInResults(dataset.requesters, item)"
                                    no-data-text="Nenhum solicitante encontrado" clearable></v-autocomplete>
                            </v-col>
                        </v-row>
                        </div>

                        <!-- Horário -->
                        <template v-if="newPassenger.passenger">
                            <div class="pax-card">
                            <div class="pax-secao"><span>2</span>
                                <div><strong>Viagem</strong><small>Horário e motivo.</small></div>
                            </div>

                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field dense outlined v-model="newPassenger.time" label="Horário de Embarque"
                                        type="time" required hide-details="auto"
                                        :disabled="selectedServiceForPassenger.type == 2"
                                        :rules="[$rules.required]"></v-text-field>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field dense label="Hora parada" type="number"
                                        v-model="newPassenger.stop_time" outlined hide-details="auto"
                                        placeholder="Insira o total de horas" min="1"
                                        :disabled="!newPassenger.passenger || (newPassenger.passenger && newPassenger.passenger.customer && !newPassenger.passenger.customer.stop_time)">
                                    </v-text-field>
                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-select dense id="reason" :items="customerTripReasonTypes" label="Motivo"
                                        v-model="newPassenger.reason" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>

                            </div>

                            <div class="pax-card">
                            <div class="pax-secao"><span>3</span>
                                <div><strong>Trajeto</strong><small>Endereços, mapa e localidade.</small></div>
                            </div>

                            <v-subheader v-if="selectedServiceForPassenger.type == 3"
                                class="pl-0 font-weight-bold">Itinerário</v-subheader>
                            <v-row v-if="selectedServiceForPassenger.type == 3">
                                <v-col cols="12">
                                    <v-autocomplete dense outlined :items="dataset.itineraries"
                                        label="Selecione um itinerário" :loading="dataset.itineraryLoading"
                                        v-model="newPassenger.itinerary_id" :search-input.sync="searchItinerary"
                                        item-value="id" cache-items no-data-text="Nenhum itinerário encontrado"
                                        item-text="name" return-object hide-details="auto" clearable
                                        :filter="item => isInResults(dataset.itineraries, item)" @change="onItinerarySelected($event)"></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-subheader class="pl-0 font-weight-bold">Origem</v-subheader>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-if="selectedServiceForPassenger.type == 1 || selectedServiceForPassenger.type == 3"
                                        :disabled="dataset.loadingEditPassenger || newPassenger.itinerary_id" dense
                                        outlined class="pax-nowrap" :items="dataset.addresses.origin"
                                        label="Endereço de Embarque"
                                        :loading="dataset.loading.origin" v-model="newPassenger.origin.address"
                                        :search-input.sync="searchAddress.origin"
                                        @update:search-input="val => getAddressByType('origin', val)" item-value="id"
                                        item-text="address" return-object hide-details="auto"
                                        :rules="[v => !!v || 'Endereço de embarque é obrigatório']" required
                                        :filter="() => true" @change="onAddressSelected('origin', $event)">
                                        <template v-slot:item="{ item }">
                                            <div class="py-2">
                                                <span v-if="item.name" class="text-caption">
                                                    <strong>{{ item.name }}</strong>
                                                    <br />
                                                </span>
                                                <span class="text-caption">
                                                    {{ item.address }}
                                                </span>
                                            </div>
                                        </template>

                                        <template v-slot:selection="{ item }">
                                            <div class="selecao-linha" :title="item.address">
                                                <span v-if="item.name" class="text-body-2">
                                                    <strong>{{ item.name }}</strong>
                                                </span>
                                                <span class="text-body-2">
                                                    {{ item.address }}
                                                </span>
                                            </div>
                                        </template>
                                    </v-autocomplete>


                                    <v-autocomplete
                                        v-else-if="newPassenger.passenger && newPassenger.passenger.customer && newPassenger.passenger.customer.addresses.length"
                                        no-data-text="Digite ao menos 3 letras para buscar o endereço" dense
                                        :items="itensEnderecoEmpresa('origin')" :loading="dataset.loading.origin"
                                        :search-input.sync="searchAddress.origin"
                                        @update:search-input="val => getAddressByType('origin', val)"
                                        :filter="() => true"
                                        label="Endereço de Embarque (Empresa)" v-model="newPassenger.origin.address"
                                        item-value="id" item-text="address" outlined hide-details="auto" return-object
                                        @change="onAddressSelected('origin', $event)">
                                        <template v-slot:item="{ item }">
                                            <div class="py-2">
                                                <span v-if="item.name" class="text-caption">
                                                    <strong>{{ item.name }}</strong>
                                                    <br />
                                                </span>
                                                <span class="text-caption">
                                                    {{ item.address }}
                                                </span>
                                            </div>
                                        </template>
                                        <template v-slot:selection="{ item }">
                                            <div class="selecao-linha" :title="item.address">
                                                <span v-if="item.name" class="text-body-2">
                                                    <strong>{{ item.name }}</strong>
                                                </span>
                                                <span class="text-body-2">
                                                    {{ item.address }}
                                                </span>
                                            </div>
                                        </template>
                                    </v-autocomplete>

                                    <span v-else-if="newPassenger.passenger && newPassenger.passenger.customer">Nenhum
                                        endereço encontrado para a empresa <strong>{{
                                            newPassenger.passenger.customer.name }}</strong></span>
                                </v-col>
                            </v-row>

                            <v-subheader class="pl-0 font-weight-bold">Destino</v-subheader>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-if="selectedServiceForPassenger.type == 2 || selectedServiceForPassenger.type == 3"
                                        :disabled="dataset.loadingEditPassenger || newPassenger.itinerary_id" dense
                                        outlined class="pax-nowrap" :items="dataset.addresses.destination"
                                        label="Endereço de destino"
                                        :loading="dataset.loading.destination"
                                        v-model="newPassenger.destination.address"
                                        :search-input.sync="searchAddress.destination"
                                        :rules="[v => !!v || 'Endereço de destino é obrigatório']" required
                                        @update:search-input="val => !dataset.loadingEditPassenger ? getAddressByType('destination', val) : null"
                                        item-value="id" item-text="address" return-object hide-details="auto"
                                        :filter="() => true" @change="onAddressSelected('destination', $event)">
                                        <template v-slot:item="{ item }">
                                            <div class="py-2">
                                                <span v-if="item.name" class="text-caption">
                                                    <strong>{{ item.name }}</strong>
                                                    <br />
                                                </span>
                                                <span class="text-caption">
                                                    {{ item.address }}
                                                </span>
                                            </div>
                                        </template>

                                        <template v-slot:selection="{ item }">
                                            <div class="selecao-linha" :title="item.address">
                                                <span v-if="item.name" class="text-body-2">
                                                    <strong>{{ item.name }}</strong>
                                                </span>
                                                <span class="text-body-2">
                                                    {{ item.address }}
                                                </span>
                                            </div>
                                        </template>
                                    </v-autocomplete>

                                    <v-autocomplete
                                        v-else-if="newPassenger.passenger && newPassenger.passenger.customer && newPassenger.passenger.customer.addresses.length"
                                        no-data-text="Digite ao menos 3 letras para buscar o endereço" dense
                                        :items="itensEnderecoEmpresa('destination')" :loading="dataset.loading.destination"
                                        :search-input.sync="searchAddress.destination"
                                        @update:search-input="val => getAddressByType('destination', val)"
                                        :filter="() => true"
                                        label="Endereço de Destino (Empresa)" v-model="newPassenger.destination.address"
                                        item-value="id" item-text="address" outlined hide-details="auto" return-object
                                        @change="onAddressSelected('destination', $event)">
                                        <template v-slot:item="{ item }">
                                            <div class="py-2">
                                                <span v-if="item.name" class="text-caption">
                                                    <strong>{{ item.name }}</strong>
                                                    <br />
                                                </span>
                                                <span class="text-caption">
                                                    {{ item.address }}
                                                </span>
                                            </div>
                                        </template>
                                        <template v-slot:selection="{ item }">
                                            <div class="selecao-linha" :title="item.address">
                                                <span v-if="item.name" class="text-body-2">
                                                    <strong>{{ item.name }}</strong>
                                                </span>
                                                <span class="text-body-2">
                                                    {{ item.address }}
                                                </span>
                                            </div>
                                        </template>
                                    </v-autocomplete>

                                    <span v-else-if="newPassenger.passenger && newPassenger.passenger.customer">Nenhum
                                        endereço encontrado para a empresa <strong>{{
                                            newPassenger.passenger.customer.name }}</strong></span>
                                </v-col>
                            </v-row>

                            <v-subheader class="pl-0 font-weight-bold">Localidade</v-subheader>
                            <v-row>
                                <v-col cols="12">
                                    <v-autocomplete :disabled="newPassenger.itinerary_id" dense outlined
                                        :items="dataset.locations" label="Selecione uma localidade"
                                        :loading="dataset.locationLoading" v-model="newPassenger.location"
                                        :search-input.sync="searchLocation" item-value="id" cache-items
                                        no-data-text="Nenhuma localidade encontrada" item-text="name" clearable
                                        hint="Deixe vazio para usar a cidade do endereço" persistent-hint
                                        :filter="item => isInResults(dataset.locations, item)" hide-details="auto"></v-autocomplete>
                                </v-col>
                            </v-row>

                            <v-row v-if="canViewTripAmounts && selectedServiceForPassenger.type == 3 && !newPassenger.itinerary_id">
                                <v-col>
                                    <v-checkbox v-model="newPassenger.createItinerary" label="Criar itinerário"
                                        color="primary" hide-details />
                                </v-col>
                            </v-row>

                            <v-row v-if="
                                canViewTripAmounts &&
                                selectedServiceForPassenger.type == 3 &&
                                !newPassenger.itinerary_id &&
                                newPassenger.createItinerary
                            ">
                                <v-col cols="6">
                                    <v-text-field dense label="Nome do itinerário"
                                        v-model="newPassenger.newItineraryName" required outlined hide-details="auto"
                                        :rules="[$rules.required]">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-currency-field dense label="Valor do itinerário" prefix="R$"
                                        v-model="newPassenger.newItineraryValue" outlined hide-details="auto"
                                        :rules="[v => (v !== null && v !== '' && Number(v) > 0) || 'Informe o valor do itinerário']"
                                        hint="Valor total do trajeto, dividido entre os passageiros da viagem"
                                        persistent-hint>
                                    </v-currency-field>
                                </v-col>
                            </v-row>

                            </div>

                            <div class="pax-card">
                            <div class="pax-secao"><span>4</span>
                                <div><strong>Complementos</strong><small>Justificativa e observações.</small></div>
                            </div>

                            <v-row>
                                <v-col cols="12">
                                    <v-text-field dense label="Justificativa" type="text"
                                        v-model="newPassenger.justification" outlined hide-details="auto"
                                        placeholder="Insira pelo menos 20 caracteres" maxlength="100" counter="100">
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-textarea dense label="Observação" rows="3" auto-grow
                                        v-model="newPassenger.observation" outlined hide-details="auto" maxlength="150"
                                        counter="150">
                                    </v-textarea>
                                </v-col>
                            </v-row>

                            <v-row v-if="canViewTripAmounts && newPassenger.id">
                                <v-col cols="12">
                                    <div class="values-section">
                                        <div class="values-title">
                                            <v-icon small color="primary" class="mr-1">mdi-cash-edit</v-icon>
                                            Valor do passageiro
                                        </div>

                                        <div class="value-preview">
                                            <span class="value-preview-label">
                                                {{ newPassenger.manual_value ? 'Valor definido' : 'Calculado pelo sistema' }}
                                            </span>
                                            <span class="value-preview-amount"
                                                :class="{ 'is-manual': newPassenger.manual_value }">
                                                R$ {{ (passengerPreviewValue || 0) | currency }}
                                            </span>
                                        </div>

                                        <v-switch v-model="newPassenger.manual_value" color="primary" hide-details
                                            dense class="mt-2 mb-0" label="Definir valor manualmente"
                                            @change="onManualValueToggle" />

                                        <v-row dense v-if="newPassenger.manual_value" class="mt-1">
                                            <v-col cols="12" sm="6">
                                                <v-currency-field dense label="Valor do passageiro" prefix="R$"
                                                    v-model="newPassenger.value" outlined hide-details="auto">
                                                </v-currency-field>
                                            </v-col>
                                        </v-row>

                                        <p class="values-hint mt-2 mb-0">
                                            {{ newPassenger.manual_value
                                                ? 'O sistema não recalcula este valor até a opção ser desligada.'
                                                : 'O valor vem da localidade e é dividido entre os passageiros da viagem.' }}
                                        </p>
                                    </div>
                                </v-col>
                            </v-row>
                            </div>
                        </template>

                    </v-form>
                </v-card-text>

                <aside class="add-pax-modal__mapa" v-if="newPassenger.passenger">
                    <LMap ref="mapaPax" :zoom="14" :center="paxCentro" :options="{ zoomControl: false }"
                        class="add-pax-modal__canvas" @click="aoClicarMapaPax" @ready="aoMapaPaxPronto">
                        <LTileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution="&copy; <a href=&quot;https://www.openstreetmap.org/copyright&quot;>OpenStreetMap</a>" />
                        <LControlZoom position="bottomright" />

                        <LMarker v-if="paxCoordsOrigem" :lat-lng="paxCoordsOrigem"
                            :draggable="!newPassenger.itinerary_id" @dragend="aoArrastarPaxPin('origin', $event)">
                            <LIcon :icon-anchor="[15, 38]" :icon-size="[30, 40]" class-name="add-pax-modal__icone">
                                <div class="add-pax-pin add-pax-pin--origem" title="Embarque"><span>A</span></div>
                            </LIcon>
                        </LMarker>
                        <LMarker v-if="paxCoordsDestino" :lat-lng="paxCoordsDestino"
                            :draggable="!newPassenger.itinerary_id" @dragend="aoArrastarPaxPin('destination', $event)">
                            <LIcon :icon-anchor="[15, 38]" :icon-size="[30, 40]" class-name="add-pax-modal__icone">
                                <div class="add-pax-pin add-pax-pin--destino" title="Destino"><span>B</span></div>
                            </LIcon>
                        </LMarker>

                        <LPolyline v-if="paxTracado.length" :lat-lngs="paxTracado" :color="'#1450b5'" :weight="5"
                            :opacity="0.8" :line-cap="'round'" :line-join="'round'" />
                        <LPolyline v-else-if="paxCoordsOrigem && paxCoordsDestino"
                            :lat-lngs="[paxCoordsOrigem, paxCoordsDestino]" :color="'#1450b5'" :weight="4"
                            :opacity="0.75" :dash-array="'1 10'" :line-cap="'round'" />
                    </LMap>

                    <div class="add-pax-flutuante add-pax-flutuante--topo">
                        <div class="add-pax-abas">
                            <button type="button"
                                v-for="campo in [{ id: 'origin', label: 'Origem (A)' }, { id: 'destination', label: 'Destino (B)' }]"
                                :key="campo.id" class="add-pax-aba"
                                :class="{ 'is-ativa': campoAtivoPax === campo.id }" @click="campoAtivoPax = campo.id">
                                <span class="add-pax-bolinha" :class="`add-pax-bolinha--${campo.id}`" />
                                {{ campo.label }}
                            </button>
                        </div>
                        <div class="add-pax-cartao add-pax-dica">
                            Clique no mapa para reposicionar o PIN de
                            <strong>{{ campoAtivoPax === 'origin' ? 'origem (A)' : 'destino (B)' }}</strong>
                            ou arraste o marcador.
                        </div>
                        <v-btn small outlined color="primary" class="add-pax-buscar" :loading="resolvendoPax"
                            :disabled="!paxPendentes.length" @click="buscarEnderecosPax">
                            <v-icon left small>mdi-map-search-outline</v-icon>Buscar endereço
                        </v-btn>
                    </div>

                    <div class="add-pax-flutuante add-pax-flutuante--base">
                        <div class="add-pax-cartao">
                            <div class="add-pax-linha">
                                <span class="add-pax-bolinha add-pax-bolinha--origin" />
                                <div class="add-pax-texto">
                                    <strong>{{ (newPassenger.origin && newPassenger.origin.address && newPassenger.origin.address.address) || 'Informe o embarque' }}</strong>
                                    <small v-if="paxCoordsOrigem">{{ paxCoordsOrigem.lat.toFixed(6) }}, {{ paxCoordsOrigem.lng.toFixed(6) }}</small>
                                </div>
                            </div>
                            <div class="add-pax-linha">
                                <span class="add-pax-bolinha add-pax-bolinha--destination" />
                                <div class="add-pax-texto">
                                    <strong>{{ (newPassenger.destination && newPassenger.destination.address && newPassenger.destination.address.address) || 'Informe o destino' }}</strong>
                                    <small v-if="paxCoordsDestino">{{ paxCoordsDestino.lat.toFixed(6) }}, {{ paxCoordsDestino.lng.toFixed(6) }}</small>
                                </div>
                            </div>
                            <div v-if="rotaPax" class="add-pax-rota">
                                <v-icon small color="primary">mdi-map-marker-distance</v-icon>
                                {{ (rotaPax.distance / 1000).toFixed(1) }} km
                                <span class="mx-1">•</span>
                                {{ Math.round(rotaPax.duration / 60) }} min
                            </div>
                        </div>
                    </div>
                </aside>
                </div>

                <v-card-actions class="add-pax-modal__actions">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" v-if="!newPassenger.id" @click="saveNewPassenger()"
                        :loading="dataList.loading">Adicionar</v-btn>
                    <v-btn color="primary" v-else @click="updatePassenger()"
                        :loading="dataList.loading">Atualizar</v-btn>
                    <v-btn text color="grey darken-1" @click="dialogAddPassenger = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL RECALCULAR VIAGENS -->
        <v-dialog v-model="dialogRecalculate" max-width="550px" persistent>
            <v-card class="pa-3">
                <v-card-title>
                    <v-icon large class="mr-2 orange--text text--darken-2">mdi-calculator-variant</v-icon>
                    Recalcular Viagens
                </v-card-title>
                <v-card-text class="pt-4">
                    <!-- Estado: formulario de filtros -->
                    <template v-if="!recalculate.processing && !recalculate.finished">
                        <v-alert type="warning" dense outlined class="mb-4">
                            Recalcula o valor de todas as viagens no periodo selecionado.
                            Periodo maximo: <strong>3 dias</strong>. Limite: <strong>500 viagens</strong>.
                        </v-alert>
                        <v-form ref="recalculateForm">
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field dense label="Data inicio *" v-model="recalculate.date_start"
                                        type="date" outlined hide-details="auto"
                                        :rules="[v => !!v || 'Obrigatorio']"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field dense label="Data fim *" v-model="recalculate.date_end"
                                        type="date" outlined hide-details="auto"
                                        :rules="[v => !!v || 'Obrigatorio']"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field dense label="N. OS (opcional)" v-model="recalculate.id"
                                        outlined hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-autocomplete dense :items="recalculateCustomers" label="Empresa (opcional)"
                                        v-model="recalculate.customer_id" item-value="id" item-text="name" outlined
                                        hide-details="auto" :loading="recalculateCustomerLoading"
                                        :search-input.sync="searchRecalculateCustomer" cache-items
                                        :filter="item => isInResults(recalculateCustomers, item)"
                                        no-data-text="Nenhuma empresa encontrada" clearable>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-form>
                    </template>

                    <!-- Estado: processando -->
                    <template v-if="recalculate.processing">
                        <div class="text-center mb-4">
                            <v-icon size="48" color="orange darken-2" class="mb-2">mdi-cog-sync-outline</v-icon>
                            <p class="text-subtitle-1 font-weight-bold mb-1">Recalculando viagens...</p>
                            <p class="text-caption grey--text">Nao feche esta janela. O processo esta em andamento.</p>
                        </div>
                        <v-progress-linear
                            :value="recalculateProgress"
                            height="25"
                            color="orange darken-2"
                            rounded
                            striped
                            class="mb-2">
                            <template v-slot:default>
                                <strong class="white--text">{{ recalculate.processed }} / {{ recalculate.total }}</strong>
                            </template>
                        </v-progress-linear>
                        <div class="d-flex justify-space-between text-caption grey--text mt-1">
                            <span>Processadas: {{ recalculate.processed }}</span>
                            <span v-if="recalculate.errors > 0" class="red--text">Erros: {{ recalculate.errors }}</span>
                            <span>Total: {{ recalculate.total }}</span>
                        </div>
                    </template>

                    <!-- Estado: finalizado -->
                    <template v-if="recalculate.finished">
                        <div class="text-center mb-4">
                            <v-icon size="48" :color="recalculate.errors > 0 ? 'orange' : 'green'" class="mb-2">
                                {{ recalculate.errors > 0 ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline' }}
                            </v-icon>
                            <p class="text-subtitle-1 font-weight-bold mb-1">Recalculo finalizado!</p>
                        </div>
                        <v-progress-linear
                            :value="100"
                            height="25"
                            :color="recalculate.errors > 0 ? 'orange' : 'green'"
                            rounded
                            class="mb-3">
                            <template v-slot:default>
                                <strong class="white--text">{{ recalculate.processed }} / {{ recalculate.total }}</strong>
                            </template>
                        </v-progress-linear>
                        <v-row class="text-center">
                            <v-col>
                                <p class="text-h6 green--text mb-0">{{ recalculate.processed - recalculate.errors }}</p>
                                <p class="text-caption">Recalculadas</p>
                            </v-col>
                            <v-col v-if="recalculate.errors > 0">
                                <p class="text-h6 red--text mb-0">{{ recalculate.errors }}</p>
                                <p class="text-caption">Erros</p>
                            </v-col>
                            <v-col>
                                <p class="text-h6 mb-0">{{ recalculate.total }}</p>
                                <p class="text-caption">Total</p>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <template v-if="!recalculate.processing && !recalculate.finished">
                        <v-btn color="grey darken-1" text @click="dialogRecalculate = false">Cancelar</v-btn>
                        <v-btn color="orange darken-2" dark @click="confirmRecalculate()"
                            :loading="recalculate.loading">
                            <v-icon left small>mdi-calculator-variant</v-icon>
                            Recalcular
                        </v-btn>
                    </template>
                    <template v-if="recalculate.finished">
                        <v-btn color="primary" @click="closeRecalculate()">Fechar</v-btn>
                    </template>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- MODAL EXCLUIR VIAGEM -->
        <v-dialog v-model="dialogConfirmDelete" max-width="400px">
            <v-card>
                <v-card-title>
                    <v-icon large class="mr-2 error--text">mdi-alert-circle-outline</v-icon>
                    Aviso
                </v-card-title>
                <v-card-text class="pt-4 black--text">
                    Você tem certeza que deseja cancelar o serviço N.OS: <strong>{{ serviceToDelete ? serviceToDelete.id
                        : ''
                        }}</strong>?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" text @click="dialogConfirmDelete = false">Cancelar</v-btn>
                    <v-btn color="error darken-1" text @click="deleteTrip">Continuar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="cancellationRequests.dialog" max-width="1100px" scrollable>
            <v-card>
                <v-toolbar color="primary" dark flat>
                    <v-toolbar-title>Solicitações de cancelamento</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="cancellationRequests.dialog = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>

                <v-card-text class="pa-5">
                    <div class="cancellation-toolbar mb-4">
                        <v-select v-model="cancellationRequests.status" :items="cancellationStatusOptions"
                            item-text="name" item-value="id" label="Situação" outlined dense hide-details
                            @change="loadCancellationRequests"></v-select>
                        <v-btn outlined color="primary" :loading="cancellationRequests.loading"
                            @click="loadCancellationRequests">
                            <v-icon left>mdi-refresh</v-icon>Atualizar
                        </v-btn>
                    </div>

                    <v-data-table :headers="cancellationHeaders" :items="cancellationRequests.data"
                        :loading="cancellationRequests.loading" :server-items-length="cancellationRequests.total"
                        :options.sync="cancellationRequests.options" :footer-props="cancellationFooterOptions"
                        disable-sort no-data-text="Nenhuma solicitação encontrada"
                        loading-text="Carregando solicitações...">
                        <template v-slot:[`item.trip_id`]="{ item }">
                            <strong class="primary--text">#{{ item.trip_id }}</strong>
                        </template>
                        <template v-slot:[`item.trip.date`]="{ item }">
                            <span v-if="item.trip">{{ formatCancellationTripDate(item.trip) }}</span>
                            <span v-else>N/A</span>
                        </template>
                        <template v-slot:[`item.customer`]="{ item }">
                            {{ cancellationCustomerName(item) }}
                        </template>
                        <template v-slot:[`item.requester`]="{ item }">
                            {{ item.requester ? item.requester.name : 'N/A' }}
                        </template>
                        <template v-slot:[`item.reason`]="{ item }">
                            <div class="cancellation-reason">{{ item.reason }}</div>
                        </template>
                        <template v-slot:[`item.created_at`]="{ item }">
                            {{ $moment(item.created_at).format('DD/MM/YYYY HH:mm') }}
                        </template>
                        <template v-slot:[`item.status`]="{ item }">
                            <v-chip :color="cancellationStatusColor(item.status)" dark small>
                                {{ cancellationStatusLabel(item.status) }}
                            </v-chip>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn v-if="item.status === 'pending'" small color="primary" elevation="0"
                                @click="openCancellationReview(item)">Analisar</v-btn>
                            <v-btn v-else small text color="primary" @click="openCancellationReview(item)">Detalhes</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="cancellationReview.dialog" max-width="650px" persistent>
            <v-card v-if="cancellationReview.item">
                <v-card-title>Analisar cancelamento da OS #{{ cancellationReview.item.trip_id }}</v-card-title>
                <v-card-text>
                    <v-alert v-if="cancellationReview.item.status !== 'pending'" text
                        :type="cancellationReview.item.status === 'approved' ? 'success' : 'info'">
                        Solicitação {{ cancellationStatusLabel(cancellationReview.item.status).toLowerCase() }}
                        em {{ cancellationReview.item.reviewed_at ? $moment(cancellationReview.item.reviewed_at).format('DD/MM/YYYY HH:mm') : 'data não informada' }}.
                    </v-alert>
                    <div class="cancellation-review-summary">
                        <div><span>Cliente</span><strong>{{ cancellationCustomerName(cancellationReview.item) }}</strong></div>
                        <div><span>Solicitante</span><strong>{{ cancellationReview.item.requester ? cancellationReview.item.requester.name : 'N/A' }}</strong></div>
                        <div><span>Viagem</span><strong>{{ cancellationReview.item.trip ? formatCancellationTripDate(cancellationReview.item.trip) : 'N/A' }}</strong></div>
                        <div class="full"><span>Itinerário</span><strong>{{ cancellationReview.item.trip ? cancellationReview.item.trip.itinerary || 'N/A' : 'N/A' }}</strong></div>
                        <div class="full"><span>Motivo informado pelo cliente</span><strong>{{ cancellationReview.item.reason }}</strong></div>
                    </div>
                    <v-textarea v-if="cancellationReview.item.status === 'pending'" v-model="cancellationReview.note"
                        class="mt-5" label="Observação da análise" outlined rows="3" counter="1000"></v-textarea>
                    <v-textarea v-else :value="cancellationReview.item.review_note || 'Nenhuma observação registrada.'"
                        class="mt-5" label="Observação da análise" outlined rows="3" readonly></v-textarea>
                    <v-alert v-if="cancellationReview.item.status === 'pending'" type="warning" text dense>
                        Ao aprovar, a viagem será alterada para Cancelado. A aprovação só será aceita se a OS ainda estiver pendente.
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeCancellationReview">Fechar</v-btn>
                    <template v-if="cancellationReview.item.status === 'pending'">
                        <v-btn outlined color="error" :loading="cancellationReview.loading"
                            @click="reviewCancellation('rejected')">Rejeitar</v-btn>
                        <v-btn color="success" :loading="cancellationReview.loading"
                            @click="reviewCancellation('approved')">Aprovar cancelamento</v-btn>
                    </template>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';
import { eventHub } from '@/main';
import moment from 'moment';
import 'moment/locale/pt-br';

import object from "@/common/util/object"

import serviceTypes from "@/common/data/service-status-types.data"
import tripPassengerStatus from "@/common/data/trip-passenger-status.data"
import tripReasonTypes from '@/common/data/trip-reason-types.data'

import TripMap from '@/layouts/components/maps/ServiceMap.vue'
import TripStopsEditor from '@/layouts/components/trip/TripStopsEditor.vue'
import TripManager from '@/layouts/components/trip/TripManager.vue'
import TripBulkStatusDialog from '@/layouts/components/trip/TripBulkStatusDialog.vue'
import RouteItinerary from '@/layouts/components/trip/RouteItinerary.vue'
import { LMap, LTileLayer, LMarker, LIcon, LPolyline, LControlZoom } from 'vue2-leaflet'

import debounce from 'lodash/debounce'

Vue.use(VueLodash)

export default {
    name: "ServiceList",
    components: {
        TripMap,
        TripStopsEditor,
        TripManager,
        TripBulkStatusDialog,
        RouteItinerary,
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
        LPolyline,
        LControlZoom,
    },

    filters: {
        formatTime(datetime) {
            if (!datetime) return 'N/A';
            const date = new Date(datetime);
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        },

    },

    data: () => ({
        dataset: {
            data: {
                status: 1
            },
            customers: [],
            tolls: [],
            tripReasonTypes: tripReasonTypes,
            serviceTypes: serviceTypes,
            tripPassengerStatus: tripPassengerStatus,
            drivers: [],
            vehicles: [],
            passengers: [],
            itineraries: [],
            locations: [],
            requesters: [],
            holidays: [],
            costCenters: [],
            passengerLoading: false,
            itineraryLoading: false,
            locationLoading: false,
            vehicleLoading: false,
            driverLoading: false,
            customerLoading: false,
            loading: {
                origin: false,
                destination: false
            },
            loadingTolls: false,
            loadingHolidays: false,
            loadingCostCenter: false,
            addresses: {
                origin: [],
                destination: []
            },
            passengerSelected: {},
            loadingEditPassenger: false
        },
        filterCustomers: [],
        filterCustomerLoading: false,
        dataList: {
            filter: {
                type: null
            },
            headers: [
                { text: "N. OS", value: "id" },
                { text: "Data/Hora", value: "dateTimeCombined" },
                { text: "Itinerário", value: "itinerary" },
                // { text: "Solicitante", value: "requester.name" },
                { text: "Motorista", value: "driver.nickname" },
                { text: 'Veículo', value: 'vehicle_icon', sortable: false, align: 'center' },
                { text: "Status", value: "status" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 50,
                sortBy: ['id'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [20, 50, 100],
                pageText: '{0}-{1} de {2}',
            },
        },
        mapTripsData: [],

        // MODAL DETALHES
        selectedItemDetails: null,
        dialogService: false,
        loadingModalDetails: false,
        tripHistory: {
            loading: false,
            error: false,
            items: [],
        },

        // STATUS

        statusMap: {
            1: 'Pendente',
            2: 'Cancelado',
            3: 'Concluído',
            4: 'Em andamento',
            5: 'Confirmado',
        },

        statusColors: {
            1: 'yellow',
            4: 'blue',
            3: 'green',
            2: 'red',
            5: 'purple',
        },

        //MODAL DE ADICIONAR MOTORISTA
        dialogAddDriver: false,

        bulkStatusOpen: false,

        tripManager: {
            open: false,
            tripId: null,
            // Acao de passageiro feita a partir da gestao: recarrega a gestao
            // quando a listagem for recarregada ao final do fluxo
            pendingReload: false,
            // Formulario de passageiro aberto a partir da gestao: a gestao sai
            // de cena e volta quando o formulario fechar
            returnAfterPassengerForm: false
        },

        stopsDialog: {
            open: false,
            loading: false,
            editable: true,
            trip: null,
            stops: []
        },

        dialogClone: false,
        cloneForm: {
            trip: null,
            quantity: 1,
            type: null,
            date: null,
            time: null,
            clonePassengers: false,
            passenger_ids: [],
            loading: false
        },
        serviceToAssignDriver: null,

        //MODAL DE ADICIONAR PASSAGEIRO
        dialogAddPassenger: false,
        // Qual PIN o clique no mapa reposiciona
        campoAtivoPax: 'origin',
        // Rota do Waybuilder entre embarque e destino (distancia/duracao/geometria)
        rotaPax: null,
        // Indica que os pontos estao sendo resolvidos em endereco
        resolvendoPax: false,
        selectedServiceForPassenger: null,
        newPassenger: {
            passenger: null,
            createItinerary: false,
            newItineraryName: "",
            newItineraryValue: null,
            time: "",
            origin: {
                coords: [],
                address: {
                    address: "",
                    city: "",
                    state: ""
                }
            },
            destination: {
                coords: [],
                address: {
                    address: "",
                    city: "",
                    state: ""
                }
            }
        },

        passengerFormValid: false,

        searchAddress: {
            origin: '',
            destination: ''
        },

        abortControllers: {
            origin: null,
            destination: null
        },
        sessionTokens: {
            origin: null,
            destination: null
        },

        searchPassenger: '',
        searchVehicle: '',
        searchRequester: '',
        searchDriver: '',
        searchCustomer: '',
        searchFilterCustomer: '',

        searchItinerary: '',
        searchLocation: '',

        // MODAL DO MAPA
        dialogMap: false,
        mapServiceDetails: null,

        // DADOS DO MODAL DE CRIAR VIAGEM
        dialogTrip: false,
        newTrip: {
            vehicle_id: null,
            driver_id: null,
            type: null,
            date: "",
            time: ""
        },
        tripFormValid: false,

        tripTypes: [
            { text: 'Entrada', value: 1 },
            { text: 'Saída', value: 2 },
            { text: 'Personalizado', value: 3 },
        ],

        //MODAL EXCLUIR VIAGEM
        dialogConfirmDelete: false,
        serviceToDelete: null,

        //MODAL RECALCULAR VIAGENS
        dialogRecalculate: false,
        recalculate: {
            date_start: '',
            date_end: '',
            id: '',
            customer_id: null,
            loading: false,
            processing: false,
            finished: false,
            total: 0,
            processed: 0,
            errors: 0,
        },
        recalculatePollingTimer: null,
        recalculateCustomers: [],
        recalculateCustomerLoading: false,
        searchRecalculateCustomer: '',

        cancellationRequests: {
            dialog: false,
            loading: false,
            data: [],
            total: 0,
            pendingCount: 0,
            status: 'pending',
            options: {
                page: 1,
                itemsPerPage: 20,
            },
        },
        cancellationReview: {
            dialog: false,
            loading: false,
            item: null,
            note: '',
        },
        cancellationStatusOptions: [
            { id: 'pending', name: 'Pendentes' },
            { id: 'approved', name: 'Aprovadas' },
            { id: 'rejected', name: 'Rejeitadas' },
            { id: null, name: 'Todas' },
        ],
        cancellationHeaders: [
            { text: 'OS', value: 'trip_id', width: 75 },
            { text: 'Data/Hora', value: 'trip.date', width: 135 },
            { text: 'Cliente', value: 'customer', width: 180 },
            { text: 'Solicitante', value: 'requester', width: 170 },
            { text: 'Motivo', value: 'reason' },
            { text: 'Solicitado em', value: 'created_at', width: 145 },
            { text: 'Situação', value: 'status', width: 115 },
            { text: 'Ações', value: 'actions', width: 105, align: 'center' },
        ],
        cancellationFooterOptions: {
            itemsPerPageText: 'Itens por página:',
            itemsPerPageOptions: [10, 20, 50],
            pageText: '{0}-{1} de {2}',
        },

    }),

    computed: {
        // ----- Mapa do modal de passageiro -----
        paxCoordsOrigem() {
            return this.paraLatLngPax(this.newPassenger.origin);
        },

        paxCoordsDestino() {
            return this.paraLatLngPax(this.newPassenger.destination);
        },

        paxCentro() {
            const a = this.paxCoordsOrigem;
            const b = this.paxCoordsDestino;
            if (a && b) return { lat: (a.lat + b.lat) / 2, lng: (a.lng + b.lng) / 2 };
            return a || b || { lat: -30.0346, lng: -51.2177 };
        },

        paxTracado() {
            const geo = this.rotaPax && this.rotaPax.geometry;
            if (!geo || typeof geo !== 'string') return [];
            return this.decodificarPolylinePax(geo);
        },

        // Muda quando qualquer coordenada muda; o watcher refaz a rota
        assinaturaRotaPax() {
            return JSON.stringify([this.paxCoordsOrigem, this.paxCoordsDestino]);
        },

        // Pontos com coordenada mas sem cidade: pin movido sem buscar endereco
        paxPendentes() {
            return ['origin', 'destination'].filter(campo => {
                const p = this.newPassenger[campo];
                return this.paraLatLngPax(p) && !(p.address && p.address.city);
            });
        },

        // Mostra quanto o passageiro vai ficar antes de salvar: com valor manual
        // ligado, o que foi digitado; sem ele, o valor que o sistema calculou.
        passengerPreviewValue() {
            if (this.newPassenger.manual_value) return this.newPassenger.value;

            return this.newPassenger.autoValue;
        },

        canViewTripAmounts() {
            return this.$check(['trips.view.amount']);
        },

        canViewTripHistory() {
            return this.$check(['trips.history.view']);
        },

        recalculateProgress() {
            if (!this.recalculate.total) return 0;
            return Math.round((this.recalculate.processed / this.recalculate.total) * 100);
        },

        customerTripReasonTypes() {
            const customer = this.newPassenger.customer
                || (this.newPassenger.passenger && this.newPassenger.passenger.customer);
            const justifications = this.parseJsonArray(customer && customer.justifications);

            if (!justifications.length) return this.dataset.tripReasonTypes;

            if (this.isLegacyReason(this.newPassenger.reason)) {
                const fixedReason = this.dataset.tripReasonTypes.find(item => String(item.id) === String(this.newPassenger.reason));

                return fixedReason ? [fixedReason, ...justifications] : justifications;
            }

            return justifications;
        },
    },

    beforeDestroy() {
        this.stopRecalculatePolling();
    },

    created() {
        this.load();
        if (this.$check(['trips.update'])) this.loadCancellationPendingCount();
        this.loadCustomers();
        this.loadFilterCustomers();
        this.loadDrivers();
        // this.loadVehicles();
        // this.loadPassengers();
    },

    watch: {
        'cancellationRequests.options.page'() {
            if (this.cancellationRequests.dialog) this.loadCancellationRequests();
        },

        'cancellationRequests.options.itemsPerPage'() {
            if (!this.cancellationRequests.dialog) return;
            this.cancellationRequests.options.page = 1;
            this.loadCancellationRequests();
        },

        // A transicao do dialog leva ~300ms; so depois o mapa tem o tamanho final
        dialogAddPassenger(aberto) {
            if (aberto) {
                setTimeout(() => this.ajustarMapaPax(), 350);
            } else {
                this.rotaPax = null;
                if (this._observadorMapaPax) {
                    this._observadorMapaPax.disconnect();
                    this._observadorMapaPax = null;
                }

                // Formulario aberto pela gestao da OS: volta para a gestao
                if (this.tripManager.returnAfterPassengerForm) {
                    this.tripManager.returnAfterPassengerForm = false;
                    this.tripManager.open = true;
                }
            }
        },

        // O mapa so monta ao escolher o passageiro, no meio da expansao do
        // modal - o Leaflet mede o container pela metade. Remede depois que
        // o layout assenta (segunda chamada cobre maquinas mais lentas).
        'newPassenger.passenger'(passageiro) {
            if (!passageiro) return;
            setTimeout(() => this.ajustarMapaPax(), 400);
            setTimeout(() => this.ajustarMapaPax(), 900);
        },

        // Refaz a rota (com folga para o arraste) quando as coordenadas mudam
        assinaturaRotaPax() {
            clearTimeout(this._timerRotaPax);
            this._timerRotaPax = setTimeout(() => this.buscarRotaPax(), 300);
        },

        searchPassenger(val) {
            this.loadPassengers(val);
        },

        searchCustomer(val) {
            this.loadCustomers(val);
        },

        searchFilterCustomer(val) {
            this.loadFilterCustomers(val);
        },

        searchRecalculateCustomer(val) {
            this.loadRecalculateCustomers(val);
        },

        searchItinerary(val) {
            this.loadItineraries(val);
        },

        searchLocation(val) {
            this.loadLocations(val);
        },

        searchAddress(val) {
            this.getAddressByName(val);
        },

        searchVehicle(val) {
            this.loadVehicles(val);
        },

        searchDriver(val) {
            this.loadDrivers(val);
        },

        searchRequester(val) {
            this.loadRequesters(val);
        },
    },

    methods: {
        async loadCancellationPendingCount() {
            try {
                const response = await axios.get('/api/v2/trip-cancellation-requests', {
                    params: { page: 1, limit: 1, status: 'pending' }
                });
                this.cancellationRequests.pendingCount = response.data.content.total || 0;
            } catch (error) {
                console.error('Erro ao carregar solicitações de cancelamento:', error);
            }
        },

        openCancellationRequests() {
            this.cancellationRequests.dialog = true;
            this.cancellationRequests.status = 'pending';
            this.cancellationRequests.options.page = 1;
            this.loadCancellationRequests();
        },

        async loadCancellationRequests() {
            this.cancellationRequests.loading = true;
            try {
                const params = {
                    page: this.cancellationRequests.options.page,
                    limit: this.cancellationRequests.options.itemsPerPage,
                };
                if (this.cancellationRequests.status) params.status = this.cancellationRequests.status;

                const response = await axios.get('/api/v2/trip-cancellation-requests', { params });
                this.cancellationRequests.data = response.data.content.data || [];
                this.cancellationRequests.total = response.data.content.total || 0;
                await this.loadCancellationPendingCount();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.cancellationRequests.loading = false;
            }
        },

        openCancellationReview(item) {
            this.cancellationReview.item = item;
            this.cancellationReview.note = item.review_note || '';
            this.cancellationReview.dialog = true;
        },

        closeCancellationReview() {
            if (this.cancellationReview.loading) return;
            this.cancellationReview.dialog = false;
            this.cancellationReview.item = null;
            this.cancellationReview.note = '';
        },

        async reviewCancellation(status) {
            const action = status === 'approved' ? 'aprovar o cancelamento' : 'rejeitar a solicitação';
            const confirmed = await this.$dialog.confirm({
                title: status === 'approved' ? 'Aprovar cancelamento' : 'Rejeitar cancelamento',
                text: `Deseja realmente ${action} da OS #${this.cancellationReview.item.trip_id}?`,
                actions: { false: 'Voltar', true: { text: 'Confirmar', color: status === 'approved' ? 'success' : 'error' } }
            });
            if (!confirmed) return;

            this.cancellationReview.loading = true;
            try {
                await axios.patch(`/api/v2/trip-cancellation-requests/${this.cancellationReview.item.id}`, {
                    status,
                    review_note: this.cancellationReview.note.trim() || null,
                });
                this.$dialog.notify.success(
                    status === 'approved' ? 'Cancelamento aprovado e viagem cancelada.' : 'Solicitação de cancelamento rejeitada.',
                    { position: 'top-right', timeout: 4000 }
                );
                this.cancellationReview.dialog = false;
                this.cancellationReview.item = null;
                this.cancellationReview.note = '';
                await Promise.all([this.loadCancellationRequests(), this.load()]);
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.cancellationReview.loading = false;
            }
        },

        cancellationStatusLabel(status) {
            return { pending: 'Pendente', approved: 'Aprovada', rejected: 'Rejeitada' }[status] || status;
        },

        cancellationStatusColor(status) {
            return { pending: 'orange', approved: 'green', rejected: 'red' }[status] || 'grey';
        },

        hasPendingCancellation(trip) {
            return (trip.cancellation_requests || []).some(item => item.status === 'pending');
        },

        cancellationCustomerName(item) {
            const passengers = item && item.trip && item.trip.passengers ? item.trip.passengers : [];
            const passenger = passengers.find(entry => entry.passenger && entry.passenger.customer);
            return passenger ? passenger.passenger.customer.name : 'N/A';
        },

        formatCancellationTripDate(trip) {
            return `${this.$moment(trip.date).format('DD/MM/YYYY')} ${this.$moment(trip.time, 'HH:mm:ss').format('HH:mm')}`;
        },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load();
        },

        getColorForItinerary(itinerary) {
            return itinerary ? 'accent' : 'grey';
        },

        getStatusColor(statusId) {
            return this.statusColors[statusId] || 'grey';
        },

        truncateText(text, maxLength) {
            return text ? (text.substring(0, maxLength) + (text.length > maxLength ? '...' : '')) : 'N/A';
        },

        async loadCostCenters(customer) {
            console.log('load cost centers for customer:', customer);
            this.dataset.loadingCostCenter = true;
            try {
                const response = await axios.get('/api/v2/cost-centers', { params: { start: 0, limit: 200, search: { customer_id: customer.id } } });
                this.dataset.costCenters = response.data.content.data
            } catch (error) {
                console.error("Erro ao buscar customers:", error);
            } finally {
                this.dataset.loadingCostCenter = false;
            }

        },

        changeCustomer(customer) {
            console.log('change customer ', customer)
            // this.clearPassenger();

            if (!customer) {
                this.dataset.costCenters = []
                return;
            }

            this.loadCostCenters(customer);
        },

        openModal(item) {
            this.dialogService = true;
            this.loadingModalDetails = false;
            this.selectedItemDetails = item;
            this.tripHistory = {
                loading: false,
                error: false,
                items: [],
            };

            if (this.canViewTripHistory) {
                this.loadTripHistory();
            }

            console.log('Item da listagem no modal (selectedItemDetails):', this.selectedItemDetails);
        },

        async loadTripHistory() {
            if (!this.selectedItemDetails || !this.selectedItemDetails.id) return;

            this.tripHistory.loading = true;
            this.tripHistory.error = false;

            try {
                const response = await axios.get(`api/v2/trips/${this.selectedItemDetails.id}/history`);
                this.tripHistory.items = response.data.content || [];
            } catch (error) {
                this.tripHistory.error = true;
                console.error('Erro ao carregar histórico da OS:', error);
            } finally {
                this.tripHistory.loading = false;
            }
        },

        formatTripHistoryDate(value) {
            if (!value) return 'N/A';
            return this.$moment(value).format('DD/MM/YYYY HH:mm');
        },

        getTripHistoryColor(item) {
            if (item.event === 'create') return 'green';
            if (item.event === 'delete') return 'red';
            if (item.title && item.title.toLowerCase().includes('recalculada')) return 'deep-purple';
            if (item.module === 'TripPassenger') return 'blue';
            if (item.module === 'TripPassengerPoint') return 'teal';
            if (item.module === 'TripRequest') return 'orange';
            if (item.module === 'TripStop') return 'orange darken-2';
            return 'primary';
        },

        getTripHistoryIcon(item) {
            if (item.event === 'create') return 'mdi-plus';
            if (item.event === 'delete') return 'mdi-delete-outline';
            if (item.title && item.title.toLowerCase().includes('motorista')) return 'mdi-account-tie';
            if (item.title && item.title.toLowerCase().includes('veiculo')) return 'mdi-car';
            if (item.title && item.title.toLowerCase().includes('status')) return 'mdi-progress-check';
            if (item.module === 'TripPassenger') return 'mdi-account';
            if (item.module === 'TripPassengerPoint') return 'mdi-map-marker';
            if (item.module === 'TripStop') return 'mdi-map-marker-path';
            return 'mdi-history';
        },

        openMapModal(item) {
            this.mapServiceDetails = item;
            this.dialogMap = true;
            console.log('Abrindo modal do mapa para o serviço:', item.id);
        },

        onMapModalShown() {
            this.$nextTick(() => {
                if (this.$refs.tripMapComponent && this.$refs.tripMapComponent.mapInstance) {
                    console.log('Modal do mapa mostrado, invalidando tamanho do mapa...');
                    this.$refs.tripMapComponent.mapInstance.invalidateSize();


                    if (this.$refs.tripMapComponent.routesData && this.$refs.tripMapComponent.routesData.length) {

                        this.$refs.tripMapComponent.fitBoundsToRoutes();
                    }
                } else {
                    console.warn('Referência do TripMap ou instância do mapa não encontrada ao tentar invalidar tamanho.');
                }
            });
        },

        normalize(str) {
            return str
                .normalize("NFD") // separa acentos das letras
                .replace(/[\u0300-\u036f]/g, "") // remove marcas de acento
                .toLowerCase();
        },
        customFilter(item, queryText, itemText) {
            const text = this.normalize(itemText)
            const query = this.normalize(queryText)
            return text.indexOf(query) > -1
        },

        togglePassengerExpansion(item) {
            this.$set(item, 'showDetailsExpansion', !item.showDetailsExpansion);
        },

        convertDistanceOrDuration({ distance = null, duration = null } = {}) {
            const results = {};

            if (distance !== null) {
                results.distance = (distance / 1000).toFixed(1);
            }

            if (duration !== null) {
                const totalMinutes = Math.floor(duration / 60);
                const hours = Math.floor(totalMinutes / 60);
                const minutes = totalMinutes % 60;

                if (hours > 0 && minutes > 0) {
                    results.duration = `${hours}h ${minutes}min`;
                } else if (hours > 0) {
                    results.duration = `${hours}h`;
                } else {
                    results.duration = `${minutes}min`;
                }
            }

            return results;
        },

        clearPassenger() {
            if (this.newPassenger.id) return;

            console.log('clear passenger')

            this.newPassenger.passenger = null;
            this.dataset.passengers = [];

            this.$set(this.dataset, 'passengers', []);
        },

        clearFilters() {
            this.dataList.filter = {};

            this.load();
        },

        verifyErrorTrip(item) {
            let locationError = item.passengers.find((x) => !x.location_id)
            if (locationError) {
                return `O passageiro ${locationError.passenger.name} está sem localidade definida, portanto não foi possível calcular o valor.`
            }

            let itineraryError = item.passengers.find((x) => x.itinerary && (!x.itinerary.value || x.itinerary.value == "0.00"))

            if (itineraryError) {
                return `O passageiro ${itineraryError.passenger.name} está atribuído a um itinerário sem valor definido, portanto não foi possível calcular o valor.`
            }

            return null
        },

        async load() {

            console.log("filtro: ", this.dataList.filter)

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : {};

            var limit = this.dataList.options.size;

            this.dataList.loading = true;

            try {
                const result = await axios.get('api/v2/trips', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                console.log("Dados: ", result)

                this.dataList.data = result.data.content.data;
                // this.dataList.count = this.dataList.data.length;
                this.dataList.count = result.data.content.total;

                this.dataList.data.forEach(item => {
                    if (typeof item.showDetailsExpansion === 'undefined') {
                        this.$set(item, 'showDetailsExpansion', false);
                    }
                });

                if (this.tripManager.pendingReload && this.tripManager.open && this.$refs.tripManager) {
                    this.tripManager.pendingReload = false;
                    this.$refs.tripManager.reload();
                }

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async reportManageTrip() {
            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : {};

            var limit = this.dataList.options.size;

            this.dataList.loading = true;

            try {
                const response = await axios.get('api/v2/trips/manage/report', { params: { page: this.dataList.options.page, limit: limit, search: search }, responseType: 'blob' });

                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                })

                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'relatorio_viagens.xlsx')
                document.body.appendChild(link)
                link.click()
                link.remove()

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async loadTolls() {

            this.dataset.loadingTolls = true;

            try {
                const result = await axios.get('api/tolls');

                this.dataset.tolls = result.data;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loadingTolls = false;
            }

        },

        async loadHolidays() {

            this.dataset.loadingHolidays = true;

            try {
                const result = await axios.get('api/holidays');

                this.dataset.holidays = result.data;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.loadingHolidays = false;
            }

        },

        loadFilterCustomers: debounce(async function (filter = '') {

            this.filterCustomerLoading = true;

            try {
                const result = await axios.get('api/v2/customers', { params: { start: 0, limit: 10, search: { name: filter } } });

                this.filterCustomers = result.data.content.data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.filterCustomerLoading = false;
            }

        }, 500),

        loadRecalculateCustomers: debounce(async function (filter = '') {
            this.recalculateCustomerLoading = true;
            try {
                const result = await axios.get('api/v2/customers', { params: { start: 0, limit: 10, search: { name: filter } } });
                this.recalculateCustomers = result.data.content.data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.recalculateCustomerLoading = false;
            }
        }, 500),

        loadCustomers: debounce(async function (filter = '') {

            // if (!filter) return;

            this.dataset.customerLoading = true;

            try {
                const result = await axios.get('api/v2/customers', { params: { start: 0, limit: 10, search: { name: filter } } });

                this.dataset.customers = result.data.content.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataset.customerLoading = false;
            }

        }, 500),

        loadDrivers: debounce(async function (filter = '') {
            this.dataset.driverLoading = true;

            try {
                const result = await axios.get(`/api/v2/drivers`, { params: { start: 1, limit: 50, search: { name: filter } } });

                console.log("Motoristas: ", result)

                this.dataset.drivers = result.data.content.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.driverLoading = false;
            }
        }, 1000),

        loadRequesters: debounce(async function (filter = '') {
            if (!filter) return;

            this.dataset.requesterLoading = true;

            try {
                const result = await axios.get(`/api/v2/requesters`, { params: { start: 1, limit: 10, search: { name: filter, customer_id: this.newPassenger.customer.id } } });

                this.dataset.requesters = result.data.content.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.requesterLoading = false;
            }
        }, 1000),

        parseJsonArray(value) {
            if (Array.isArray(value)) return value;
            if (!value) return [];

            try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed) ? parsed : [];
            } catch (error) {
                return [];
            }
        },

        getReasonName(customer, reason) {
            const reasons = this.parseJsonArray(customer && customer.justifications);
            const list = this.isLegacyReason(reason)
                ? [...this.dataset.tripReasonTypes, ...reasons]
                : [...reasons, ...this.dataset.tripReasonTypes];
            const found = list.find(item => String(item.id) === String(reason));

            return found ? found.name : reason;
        },

        isLegacyReason(reason) {
            return reason !== null && reason !== undefined && /^\d+$/.test(String(reason));
        },

        loadVehicles: debounce(async function (filter = '') {
            this.dataset.vehicleLoading = true;

            try {
                const result = await axios.get(`/api/v2/vehicles`, { params: { start: 1, limit: 100, search: { plate: filter } } });

                console.log("Veículos: ", result.data);

                this.dataset.vehicles = result.data.content.data.map(v => ({ id: v.id, model: { model: `${v.model.model} - ${v.plate.toUpperCase()} (Frota: ${v.code})` } }));

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.dataset.vehicleLoading = false;
            }
        }, 1000),

        loadPassengers: debounce(async function (filter) {

            if (!filter) {
                return;
            }

            this.dataset.passengerLoading = true;

            console.log("nome busca filtro: ", filter)

            try {
                const result = await axios.get(`/api/v2/passengers/list`, { params: { start: 1, limit: 10, search: { name: filter, customer_id: this.newPassenger.customer.id } } });

                this.dataset.passengers = result.data.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.passengerLoading = false;
            }
        }, 1000),

        loadItineraries: debounce(async function (filter) {

            this.dataset.itineraryLoading = true;

            console.log("nome busca filtro: ", filter)

            try {
                const result = await axios.get(`/api/v2/itineraries`, { params: { start: 1, limit: 10, search: { name: filter } } });

                this.dataset.itineraries = result.data.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.itineraryLoading = false;
            }
        }, 1000),

        loadLocations: debounce(async function (filter) {

            this.dataset.locationLoading = true;

            console.log("nome busca filtro: ", filter)

            try {
                const result = await axios.get(`/api/v2/locations`, { params: { start: 1, limit: 10, search: { name: filter, customer: this.newPassenger.customer_id } } });

                this.dataset.locations = result.data.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.locationLoading = false;
            }
        }, 1000),

        getAddressByType: debounce(async function (type, name) {
            console.log('loadingEditPassenger ', this.dataset.loadingEditPassenger);

            if (this.dataset.loadingEditPassenger) return
            if (!name || name.trim().length < 3) {
                // Mantem o endereco ja selecionado na lista: o Vuetify so
                // exibe a selecao se o item existir nos items, e este evento
                // dispara vazio ao focar/limpar - esvaziar aqui apagava o
                // endereco preenchido do cadastro do passageiro.
                const atual = this.newPassenger[type] && this.newPassenger[type].address;
                this.dataset.addresses[type] = (atual && atual.address)
                    ? [{ iid: atual.iid || null, address: atual.address }]
                    : [];
                this.sessionTokens[type] = null;
                return;
            }

            if (!this.sessionTokens[type]) {
                this.sessionTokens[type] = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : `${Date.now()}${Math.random()}`;
            }

            if (this.abortControllers[type]) {
                this.abortControllers[type].abort();
            }

            this.abortControllers[type] = new AbortController();
            this.dataset.loading[type] = true;

            try {
                const response = await axios.get(`/api/v2/google-maps/find/${encodeURIComponent(name)}`, {
                    params: { sessiontoken: this.sessionTokens[type] },
                    signal: this.abortControllers[type].signal
                });

                const resultado = response.data.content.map(x => ({
                    name: x.name,
                    lat: x.lat,
                    lng: x.lng,
                    address: x.address,
                    iid: x.placeId
                }));

                // A selecao atual permanece na lista para o campo nao
                // "apagar" enquanto a pessoa pesquisa outro endereco
                const selecionado = this.newPassenger[type] && this.newPassenger[type].address;
                if (selecionado && selecionado.address && !resultado.some(x => x.iid === selecionado.iid)) {
                    resultado.unshift({ iid: selecionado.iid || null, address: selecionado.address });
                }

                this.dataset.addresses[type] = resultado;

                console.log('addresses ', type, name, this.dataset.addresses)
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(`Erro ao buscar endereço (${type}):`, error);
                }
            } finally {
                this.dataset.loading[type] = false;
            }
        }, 500),

        viewItem(item) {
            this.$router.push(`servicos/${item.id}`);
        },

        onManualValueToggle(ligado) {
            if (ligado) {
                // Comeca do valor atual em vez de zero: normalmente o operador quer
                // ajustar o que ja esta la, nao digitar do nada.
                if (this.newPassenger.value === null || this.newPassenger.value === undefined) {
                    this.$set(this.newPassenger, 'value', this.newPassenger.autoValue || 0);
                }

                return;
            }

            // Ao desligar, o preview volta a mostrar o valor calculado pelo sistema
            this.$set(this.newPassenger, 'value', this.newPassenger.autoValue);
        },

        openCloneDialog(item) {
            this.cloneForm = {
                trip: item,
                quantity: 1,
                type: item.type,
                date: item.date ? String(item.date).slice(0, 10) : null,
                time: (item.time || '').slice(0, 5),
                clonePassengers: false,
                // Por padrao todos vem marcados; o operador desmarca quem nao vai
                passenger_ids: (item.passengers || []).map(p => p.id),
                loading: false
            };

            this.dialogClone = true;
        },

        // Buscas no servidor com cache-items: o cache guarda os resultados
        // anteriores (e a opção já escolhida), mas durante a busca só os
        // resultados atuais devem aparecer - senão o pesquisado vai para o fim.
        isInResults(results, item) {
            return !!item && (results || []).some(result => result && result.id === item.id);
        },

        openTripManager(trip) {
            this.tripManager.tripId = trip.id;
            this.tripManager.pendingReload = false;
            this.tripManager.open = true;
        },

        fromTripManager(action) {
            this.tripManager.pendingReload = true;
            action();
        },

        // Troca a gestão pelo formulário de passageiro (sem modal sobre modal);
        // ao fechar o formulário a gestão reabre e recarrega sozinha
        async passengerFormFromTripManager(action) {
            this.tripManager.returnAfterPassengerForm = true;
            this.tripManager.open = false;

            try {
                await action();
            } finally {
                // Formulário não abriu (erro ao carregar): devolve a gestão
                if (!this.dialogAddPassenger && this.tripManager.returnAfterPassengerForm) {
                    this.tripManager.returnAfterPassengerForm = false;
                    this.tripManager.open = true;
                }
            }
        },

        // Os formularios de passageiro esperam a OS e o passageiro no formato da
        // listagem (com endereco da empresa, itinerario etc.); usa esse quando a
        // OS estiver na pagina atual.
        editPassengerFromManager(trip, tripPassenger) {
            const listed = this.dataList.data.find(item => item.id === trip.id);
            const listedPassenger = listed && (listed.passengers || []).find(item => item.id === tripPassenger.id);

            this.editPassenger(listed || trip, listedPassenger || tripPassenger);
        },

        // Configuração de paradas da OS: habilitada se alguma empresa dos
        // passageiros permitir; vale o maior limite entre elas (igual ao backend)
        tripStopsConfig(trip) {
            const configs = ((trip && trip.passengers) || [])
                .map(item => item.passenger && item.passenger.customer && item.passenger.customer.settings)
                .map(settings => (typeof settings === 'string' ? this.parseJsonSafe(settings) : settings) || {})
                .map(settings => settings.stops || {})
                .filter(stops => stops.enabled);

            if (!configs.length) return { enabled: false, max: 20 };

            return { enabled: true, max: Math.max(...configs.map(stops => Number(stops.max) || 5)) };
        },

        parseJsonSafe(value) {
            try {
                return JSON.parse(value);
            } catch (error) {
                return null;
            }
        },

        canEditTripStops(trip) {
            return this.tripStopsConfig(trip).enabled || !!(trip.stops && trip.stops.length);
        },

        openStopsDialog(trip) {
            this.stopsDialog.trip = trip;
            this.stopsDialog.editable = ![2, 3].includes(Number(trip.status));
            this.stopsDialog.stops = (trip.stops || []).map(stop => ({
                id: stop.id,
                coords: [Number(stop.latitude), Number(stop.longitude)],
                address: {
                    iid: stop.iid,
                    address: stop.address,
                    city: stop.city,
                    state: stop.state,
                    district: stop.district
                },
                observation: stop.observation || '',
                arrived_at: stop.arrived_at
            }));
            this.stopsDialog.open = true;
        },

        async saveStops() {
            if (this.$refs.stopsFormRef && !this.$refs.stopsFormRef.validate()) return;

            if (this.stopsDialog.stops.some(stop => !stop.coords)) {
                this.$dialog.notify.warning('Selecione o endereço de todas as paradas.', { position: 'top-right', timeout: 4000 });
                return;
            }

            this.stopsDialog.loading = true;

            try {
                const payload = {
                    stops: this.stopsDialog.stops.map(stop => ({
                        id: stop.id || null,
                        coords: stop.coords,
                        address: stop.address,
                        observation: stop.observation || null
                    }))
                };

                const response = await axios.put(`api/v2/trips/${this.stopsDialog.trip.id}/stops`, payload);

                this.$set(this.stopsDialog.trip, 'stops', response.data.content || []);

                this.$dialog.notify.success('Pontos de parada salvos', { position: 'top-right', timeout: 3000 });
                this.stopsDialog.open = false;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 6000 });
            } finally {
                this.stopsDialog.loading = false;
            }
        },

        async saveClone() {
            if (!this.$refs.cloneFormRef.validate()) return;

            if (this.cloneForm.clonePassengers && this.cloneForm.passenger_ids.length === 0) {
                this.$dialog.notify.warning('Selecione ao menos um passageiro ou desligue a opcao de clonar passageiros.', { position: 'top-right', timeout: 4000 });
                return;
            }

            this.cloneForm.loading = true;

            try {
                const payload = {
                    quantity: this.cloneForm.quantity,
                    type: this.cloneForm.type,
                    date: this.cloneForm.date,
                    time: this.cloneForm.time,
                    clonePassengers: this.cloneForm.clonePassengers,
                    passenger_ids: this.cloneForm.clonePassengers ? this.cloneForm.passenger_ids : []
                };

                const response = await axios.post(`api/v2/trips/${this.cloneForm.trip.id}/clone`, payload);

                const criadas = response.data.content || [];

                this.$dialog.notify.success(
                    `${criadas.length} OS criada(s): ${criadas.map(id => '#' + id).join(', ')}`,
                    { position: 'top-right', timeout: 6000 }
                );

                this.dialogClone = false;
                this.cloneForm.trip = null;

                await this.load();

            } catch (error) {
                console.error('Erro ao clonar OS:', error.response ? error.response.data : error.message);
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 6000 });
            } finally {
                this.cloneForm.loading = false;
            }
        },


        async addDriverToService(serviceItem) {
            this.dataset.data = serviceItem;
            this.dialogAddDriver = true;
            await this.loadDrivers();
        },

        async saveAssignedDriver() {
            if (!this.dataset.data.driver_id) {
                this.$dialog.notify.warning("Por favor, selecione um motorista para atribuir.", { position: 'top-right', timeout: 3000 });
                return;
            }

            this.dataList.loading = true;
            try {
                const payload = {
                    driver_id: this.dataset.data.driver_id
                };

                const response = await axios.patch(`api/v2/trips/${this.dataset.data.id}`, payload);

                console.log('Resposta da API (atribuir motorista):', response.data);

                this.$dialog.notify.success("Motorista atribuído com sucesso!", { position: 'top-right', timeout: 3000 });
                this.dialogAddDriver = false;
                this.dataset.data = {}

                await this.load();

            } catch (error) {
                console.error('Erro ao atribuir motorista:', error);
                let errorMessage = "Erro desconhecido ao atribuir motorista.";
                if (error.response) {
                    console.error("Dados do erro da API:", error.response.data);
                    if (error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    } else {
                        errorMessage = `Erro do servidor: ${error.response.status}`;
                    }
                }
                this.$dialog.notify.error(`Erro ao atribuir motorista: ${errorMessage}`, { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }
        },

        async getCoordsFromPlaceId(placeId, type = null) {
            try {
                const response = await axios.get(`/api/v2/google-maps/place-details/${placeId}`, {
                    params: type && this.sessionTokens[type] ? { sessiontoken: this.sessionTokens[type] } : {}
                });

                const { coordinates, city, state } = response.data.content;

                return {
                    lat: coordinates.lat,
                    lng: coordinates.lng,
                    city,
                    state
                };
            } catch (error) {
                console.error('Erro ao buscar coordenadas:', error);
                return null;
            }
        },

        // ----- Mapa do modal de passageiro -----

        // Enderecos da empresa + o ponto atual quando ele veio do mapa: o
        // select so exibe a selecao se ela estiver entre os itens, entao o
        // "Ponto no mapa (...)" (ou o endereco resolvido) entra na lista.
        itensEnderecoEmpresa(campo) {
            const passageiro = this.newPassenger.passenger;
            const lista = [...((passageiro && passageiro.customer && passageiro.customer.addresses) || [])];

            // Resultados da busca digitada (Google) entram depois dos
            // enderecos cadastrados da empresa
            (this.dataset.addresses[campo] || []).forEach(item => {
                if (item && item.address && !lista.some(x => x.address === item.address)) lista.push(item);
            });

            // E a selecao atual (pin no mapa, por exemplo) sempre aparece
            const atual = this.newPassenger[campo] && this.newPassenger[campo].address;
            if (atual && atual.address && !lista.some(x => x.address === atual.address)) lista.push(atual);

            return lista;
        },

        paraLatLngPax(ponto) {
            const coords = ponto && ponto.coords;
            if (!Array.isArray(coords) || coords.length < 2) return null;

            const lat = Number(coords[0]);
            const lng = Number(coords[1]);
            if (!isFinite(lat) || !isFinite(lng) || (!lat && !lng)) return null;

            return { lat, lng };
        },

        // Decodifica a polyline do OSRM (precisao 5) em pares [lat, lng]
        decodificarPolylinePax(geo) {
            const pontos = [];
            let indice = 0, lat = 0, lng = 0;

            while (indice < geo.length) {
                let resultado = 0, deslocamento = 0, byte;

                do {
                    byte = geo.charCodeAt(indice++) - 63;
                    resultado |= (byte & 0x1f) << deslocamento;
                    deslocamento += 5;
                } while (byte >= 0x20);
                lat += (resultado & 1) ? ~(resultado >> 1) : (resultado >> 1);

                resultado = 0; deslocamento = 0;
                do {
                    byte = geo.charCodeAt(indice++) - 63;
                    resultado |= (byte & 0x1f) << deslocamento;
                    deslocamento += 5;
                } while (byte >= 0x20);
                lng += (resultado & 1) ? ~(resultado >> 1) : (resultado >> 1);

                pontos.push([lat / 1e5, lng / 1e5]);
            }

            return pontos;
        },

        async buscarRotaPax() {
            const a = this.paxCoordsOrigem;
            const b = this.paxCoordsDestino;

            if (!a || !b) {
                this.rotaPax = null;
                return;
            }

            try {
                const r = await axios.post('/api/v2/routes/estimate', {
                    origin: [a.lat, a.lng],
                    destination: [b.lat, b.lng]
                });
                this.rotaPax = (r.data && r.data.content) || null;
            } catch (error) {
                this.rotaPax = null;
            }

            this.$nextTick(() => this.ajustarMapaPax());
        },

        // Dispara quando o Leaflet termina de montar: mede na hora e passa a
        // observar o tamanho do container - o modal anima de 800px para
        // 1280px e o mapa cresce junto aos poucos, entao cronometro nao
        // basta: cada mudanca de tamanho remede o mapa.
        aoMapaPaxPronto() {
            this.ajustarMapaPax();

            const comp = this.$refs.mapaPax;
            const alvo = comp && comp.$el;
            if (!alvo || !window.ResizeObserver) {
                setTimeout(() => this.ajustarMapaPax(), 350);
                return;
            }

            if (this._observadorMapaPax) this._observadorMapaPax.disconnect();
            this._observadorMapaPax = new ResizeObserver(() => {
                clearTimeout(this._timerRedimensionaPax);
                this._timerRedimensionaPax = setTimeout(() => this.ajustarMapaPax(), 120);
            });
            this._observadorMapaPax.observe(alvo);
        },

        ajustarMapaPax(tentativa = 0) {
            const comp = this.$refs.mapaPax;
            const mapa = comp && comp.mapObject;
            if (!mapa) {
                // O mapa pode ainda estar montando; tenta de novo em seguida
                if (tentativa < 5) setTimeout(() => this.ajustarMapaPax(tentativa + 1), 200);
                return;
            }

            mapa.invalidateSize();

            const a = this.paxCoordsOrigem;
            const b = this.paxCoordsDestino;
            const limites = this.paxTracado.length
                ? this.paxTracado
                : (a && b ? [[a.lat, a.lng], [b.lat, b.lng]] : null);

            if (limites) {
                mapa.fitBounds(limites, { paddingTopLeft: [60, 110], paddingBottomRight: [60, 140] });
            } else {
                const ponto = a || b;
                if (ponto) mapa.setView([ponto.lat, ponto.lng], 15);
            }
        },

        aoClicarMapaPax(evento) {
            const ll = evento && evento.latlng;
            if (!ll || this.newPassenger.itinerary_id) return;

            this.moverPinPax(this.campoAtivoPax, ll.lat, ll.lng);
        },

        aoArrastarPaxPin(campo, evento) {
            const marcador = evento && evento.target;
            if (!marcador || typeof marcador.getLatLng !== 'function') return;
            if (this.newPassenger.itinerary_id) return;

            const ll = marcador.getLatLng();
            this.moverPinPax(campo, ll.lat, ll.lng);
        },

        moverPinPax(campo, lat, lng) {
            const ponto = this.newPassenger[campo];
            if (!ponto) return;

            const rotulo = `Ponto no mapa (${lat.toFixed(5)}, ${lng.toFixed(5)})`;
            this.$set(ponto, 'coords', [lat, lng]);
            // Igual ao modal de solicitacao: mover mostra a coordenada e o
            // endereco completo so vem no botao "Buscar endereço" ou na hora
            // de salvar o passageiro - cada consulta custa.
            this.$set(ponto, 'address', { iid: null, address: rotulo, city: '', state: '' });
            this.$set(this.dataset.addresses, campo, [{ iid: null, address: rotulo }]);
        },

        // Um clique resolve todos os pontos que estao so com coordenada
        async buscarEnderecosPax() {
            const pendentes = this.paxPendentes;
            if (!pendentes.length) return;

            this.resolvendoPax = true;
            try {
                await Promise.all(pendentes.map(campo => {
                    const c = this.newPassenger[campo].coords;
                    return this.resolverEnderecoPax(campo, Number(c[0]), Number(c[1]));
                }));
            } finally {
                this.resolvendoPax = false;
            }
        },

        async resolverEnderecoPax(campo, lat, lng) {
            try {
                const resposta = await axios.get('/api/v2/google-maps/resolve-coord', { params: { lat, lng } });
                const local = resposta.data && resposta.data.content;

                // Descarta se o pin mudou de lugar durante a consulta
                const ponto = this.newPassenger[campo];
                const atual = ponto && ponto.coords;
                if (!local || !Array.isArray(atual) || Number(atual[0]) !== lat || Number(atual[1]) !== lng) return;

                this.$set(ponto, 'address', {
                    iid: local.iid || null,
                    address: local.address || '',
                    city: local.city || '',
                    state: local.state || ''
                });
                // O autocomplete so exibe a selecao se o item estiver na lista
                this.$set(this.dataset.addresses, campo, [{ iid: local.iid || null, address: local.address || '' }]);
            } catch (error) {
                // Sem resposta o campo segue com o ultimo endereco valido;
                // a coordenada nova ja esta salva no ponto
            }
        },

        async onAddressSelected(type, addressObj) {
            const location = await this.getCoordsFromPlaceId(addressObj.iid, type);
            if (location) {
                this.newPassenger[type].address.iid = addressObj.iid;
                this.newPassenger[type].address.address = addressObj.address;
                this.newPassenger[type].coords = [location.lat, location.lng];
                this.newPassenger[type].address.city = location.city
                this.newPassenger[type].address.state = location.state
                this.sessionTokens[type] = null;
            }
        },

        async onPassengerSelected(passenger) {

            if (!passenger) {
                this.$set(this.newPassenger, 'origin', {});
                this.$set(this.newPassenger, 'destination', {});
                this.$set(this.newPassenger, 'cost_center_id', null);
                this.$set(this.dataset.addresses, 'origin', {});
                this.$set(this.dataset.addresses, 'destination', {});
                return;
            }

            // Centro de custo do cadastro do passageiro como padrao (o admin
            // pode trocar). Se nao estiver na lista carregada da empresa
            // (limite da busca), entra nela para o select exibir.
            this.$set(this.newPassenger, 'cost_center_id', passenger.cost_center_id || null);

            const passengerCostCenter = passenger.costCenter || passenger.cost_center;
            if (passengerCostCenter && passengerCostCenter.id
                && !this.dataset.costCenters.some(item => item.id === passengerCostCenter.id)) {
                this.dataset.costCenters.push(passengerCostCenter);
            }

            if (!passenger.address_iid) {
                this.$dialog.notify.error("Este passageiro não possui um endereço válido cadastrado.", { position: 'top-right', timeout: 5000 });
            }

            const hasStoredLocation = passenger.address_lat && passenger.address_lng && passenger.city && passenger.state;
            const location = hasStoredLocation
                ? {
                    lat: Number(passenger.address_lat),
                    lng: Number(passenger.address_lng),
                    city: passenger.city,
                    state: passenger.state
                }
                : await this.getCoordsFromPlaceId(passenger.address_iid);

            if (!location) return;

            const type = this.selectedServiceForPassenger.type == 1 ? 'origin' : 'destination';

            this.newPassenger[type] = {
                coords: [location.lat, location.lng],
                address: {
                    iid: passenger.address_iid,
                    address: passenger.address,
                    city: location.city,
                    state: location.state,
                }
            }

            this.dataset.addresses[type] = [{
                iid: passenger.address_iid,
                address: passenger.address,
            }]
        },

        onItinerarySelected(itinerary) {
            if (!itinerary) {
                this.newPassenger.location_id = null
                this.newPassenger.origin = {
                    coords: [],
                    address: {
                        address: "",
                        city: "",
                        state: ""
                    }
                }
                this.newPassenger.destination = {
                    coords: [],
                    address: {
                        address: "",
                        city: "",
                        state: ""
                    }
                }

                return;
            }

            this.newPassenger.location_id = itinerary.location_id

            this.newPassenger.origin = {
                coords: [itinerary.origin_latitude, itinerary.origin_longitude],
                address: {
                    iid: itinerary.origin_iid,
                    address: itinerary.origin_address,
                    city: itinerary.origin_city,
                    state: itinerary.origin_state,
                }
            }

            this.dataset.addresses.origin = [{
                iid: itinerary.origin_iid,
                address: itinerary.origin_address,
            }]

            this.newPassenger.destination = {
                coords: [itinerary.destination_latitude, itinerary.destination_longitude],
                address: {
                    iid: itinerary.destination_iid,
                    address: itinerary.destination_address,
                    city: itinerary.destination_city,
                    state: itinerary.destination_state,
                }
            }

            this.dataset.addresses.destination = [{
                iid: itinerary.destination_iid,
                address: itinerary.destination_address,
            }]
        },

        async addPassengerToService(serviceItem) {
            this.selectedServiceForPassenger = serviceItem;
            this.newPassenger = {
                passenger: null,
                createItinerary: false,
                newItineraryName: "",
                newItineraryValue: null,
                time: "",
                origin: {
                    coords: [],
                    address: {
                        address: "",
                        city: "",
                        state: ""
                    }
                },
                destination: {
                    coords: [],
                    address: {
                        address: "",
                        city: "",
                        state: ""
                    }
                }
            };

            if (serviceItem.type == 2) {
                this.newPassenger.time = serviceItem.time;
            }

            this.dialogAddPassenger = true;

            if (this.$refs.passengerForm) {
                this.$refs.passengerForm.resetValidation();
            }
        },

        async editPassenger(trip, data) {
            this.dataset.loadingEditPassenger = true;

            this.selectedServiceForPassenger = trip;

            this.dataset.passengerSelected = data.passenger

            this.newPassenger = {
                id: data.id,
                passenger: data.passenger,
                time: data.time,
                location: data.location_id,
                itinerary_id: data.itinerary_id,
                createItinerary: false,
                newItineraryName: "",
                newItineraryValue: null,
                manual_value: data.manual_value || false,
                value: data.value,
                // Guarda o valor vindo do sistema para o preview poder voltar a
                // exibi-lo quando o operador desligar o valor manual
                autoValue: data.manual_value ? null : data.value,
                requester_id: data.requester_id,
                cost_center_id: data.cost_center_id,
                origin: {
                    coords: [data.points[0].latitude, data.points[0].longitude],
                    address: {
                        iid: data.points[0].iid,
                        address: data.points[0].address,
                        city: data.points[0].city,
                        state: data.points[0].state,
                    }
                },
                destination: {
                    coords: [data.points[1].latitude, data.points[1].longitude],
                    address: {
                        iid: data.points[1].iid,
                        address: data.points[1].address,
                        city: data.points[1].city,
                        state: data.points[1].state,
                    }
                },
                justification: data.justification,
                reason: data.reason || null,
                observation: data.observation,
                stop_time: data.stop_time
            };

            this.newPassenger.customer = data.passenger.customer
            this.newPassenger.requester = data.requester

            this.loadCostCenters(this.newPassenger.customer)

            if (this.selectedServiceForPassenger.type == 1) {
                const destination = this.newPassenger.customer.addresses.find((x) => x.iid == this.newPassenger.destination.address.iid);

                if (destination) {
                    this.newPassenger.destination.address = destination;
                } else {
                    this.newPassenger.customer.addresses.push(this.newPassenger.destination.address)
                }
            }

            if (this.selectedServiceForPassenger.type == 2) {
                const origin = this.newPassenger.customer.addresses.find((x) => x.iid == this.newPassenger.origin.address.iid);

                if (origin) {
                    this.newPassenger.origin.address = origin;
                } else {
                    this.newPassenger.customer.addresses.push(this.newPassenger.origin.address)
                }
            }

            this.dataset.customers = [
                this.newPassenger.customer
            ]

            this.dataset.requesters = [
                this.newPassenger.requester
            ]

            this.dataset.passengers = [
                data.passenger
            ]

            this.dataset.addresses.origin = [
                {
                    iid: data.points[0].iid,
                    address: data.points[0].address,
                }
            ]

            this.dataset.addresses.destination = [
                {
                    iid: data.points[1].iid,
                    address: data.points[1].address,
                }
            ]

            this.dialogAddPassenger = true;

            if (this.$refs.passengerForm) {
                this.$refs.passengerForm.resetValidation();
            }

            // A flag so precisa cobrir o preenchimento programatico dos
            // campos (que dispara o search-input); 3s deixava tudo
            // desabilitado e parecia que o modal estava travado.
            setTimeout(() => {
                this.dataset.loadingEditPassenger = false;
            }, 400)
        },

        async updatePassenger() {
            if (!this.$refs.passengerForm.validate()) {
                this.$dialog.notify.warning("Por favor, preencha todos os campos obrigatórios do passageiro.", { position: 'top-right', timeout: 3000 });
                return;
            }

            // Os campos de latitude/longitude viraram os PINs do mapa; a
            // exigencia de coordenadas continua valendo aqui.
            const temCoords = (p) => p && Array.isArray(p.coords) && p.coords.length >= 2
                && isFinite(Number(p.coords[0])) && isFinite(Number(p.coords[1]));
            if (!temCoords(this.newPassenger.origin) || !temCoords(this.newPassenger.destination)) {
                this.$dialog.notify.warning("Posicione o embarque e o destino: escolha os endereços ou ajuste os PINs no mapa.", { position: 'top-right', timeout: 4000 });
                return;
            }

            // Pin movido sem buscar endereco: resolve agora, para o registro
            // sair com endereco completo e cidade (que define a localidade)
            if (this.paxPendentes.length) await this.buscarEnderecosPax();

            const passengerTime = moment(this.newPassenger.time, 'HH:mm');

            if (!passengerTime.isValid()) {
                this.$dialog.notify.error("Hora de embarque inválida. Por favor, use o formato HH:MM.", { position: 'top-right', timeout: 5000 });
                return;
            }

            this.dataList.loading = true;

            try {
                const tripId = this.selectedServiceForPassenger.id;
                const payload = {
                    location: this.newPassenger.location,
                    passenger: this.newPassenger.passenger.id,
                    cost_center_id: this.newPassenger.cost_center_id || this.newPassenger.passenger.cost_center_id,
                    time: this.newPassenger.time,
                    origin: {
                        coords: this.newPassenger.origin.coords,
                        address: this.newPassenger.origin.address
                    },
                    destination: {
                        coords: this.newPassenger.destination.coords,
                        address: this.newPassenger.destination.address
                    },
                    observation: this.newPassenger.observation,
                    reason: this.newPassenger.reason,
                    justification: this.newPassenger.justification,
                    stop_time: this.newPassenger.stop_time,
                    requester_id: this.newPassenger.requester_id,
                    itinerary_id: this.newPassenger.itinerary_id && this.newPassenger.itinerary_id.id ? this.newPassenger.itinerary_id.id : this.newPassenger.itinerary_id,
                    createItinerary: this.newPassenger.createItinerary || false,
                    newItineraryName: this.newPassenger.newItineraryName,
                    newItineraryValue: this.newPassenger.newItineraryValue || null,
                };

                if (this.canViewTripAmounts) {
                    payload.manual_value = !!this.newPassenger.manual_value;
                    payload.value = this.newPassenger.manual_value ? this.newPassenger.value : undefined;
                }

                const response = await axios.patch(`api/v2/trips/${tripId}/passengers/${this.newPassenger.id}`, payload);

                console.log('Resposta da API (adicionar passageiro):', response.data);

                this.$dialog.notify.success("Passageiro atualizar com sucesso à viagem!", { position: 'top-right', timeout: 3000 });
                this.dialogAddPassenger = false;
                await this.load();

            } catch (error) {
                console.error('Erro ao adicionar passageiro:', error);
                let errorMessage = "Erro desconhecido ao adicionar passageiro.";
                if (error.response) {
                    console.error("Dados do erro da API:", error.response.data);
                    if (error.response.data && error.response.data.content.error.message) {
                        errorMessage = error.response.data.content.error.message;
                    } else {
                        errorMessage = `Erro do servidor: ${error.response.status}`;
                    }
                }
                this.$dialog.notify.error(errorMessage, { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }
        },

        async saveNewPassenger() {
            if (!this.$refs.passengerForm.validate()) {
                this.$dialog.notify.warning("Por favor, preencha todos os campos obrigatórios do passageiro.", { position: 'top-right', timeout: 3000 });
                return;
            }

            // Os campos de latitude/longitude viraram os PINs do mapa; a
            // exigencia de coordenadas continua valendo aqui.
            const temCoords = (p) => p && Array.isArray(p.coords) && p.coords.length >= 2
                && isFinite(Number(p.coords[0])) && isFinite(Number(p.coords[1]));
            if (!temCoords(this.newPassenger.origin) || !temCoords(this.newPassenger.destination)) {
                this.$dialog.notify.warning("Posicione o embarque e o destino: escolha os endereços ou ajuste os PINs no mapa.", { position: 'top-right', timeout: 4000 });
                return;
            }

            // Pin movido sem buscar endereco: resolve agora, para o registro
            // sair com endereco completo e cidade (que define a localidade)
            if (this.paxPendentes.length) await this.buscarEnderecosPax();

            const passengerTime = moment(this.newPassenger.time, 'HH:mm');
            if (!passengerTime.isValid()) {
                this.$dialog.notify.error("Hora de embarque inválida. Por favor, use o formato HH:MM.", { position: 'top-right', timeout: 5000 });
                return;
            }

            this.dataList.loading = true;

            try {
                const tripId = this.selectedServiceForPassenger.id;
                const payload = {
                    location: this.newPassenger.location,
                    passenger: this.newPassenger.passenger.id,
                    cost_center_id: this.newPassenger.cost_center_id || this.newPassenger.passenger.cost_center_id,
                    time: this.newPassenger.time,
                    origin: {
                        coords: this.newPassenger.origin.coords,
                        address: this.newPassenger.origin.address
                    },
                    destination: {
                        coords: this.newPassenger.destination.coords,
                        address: this.newPassenger.destination.address
                    },
                    observation: this.newPassenger.observation,
                    reason: this.newPassenger.reason,
                    justification: this.newPassenger.justification,
                    stop_time: this.newPassenger.stop_time,
                    requester_id: this.newPassenger.requester_id,
                    itinerary_id: this.newPassenger.itinerary_id && this.newPassenger.itinerary_id.id ? this.newPassenger.itinerary_id.id : this.newPassenger.itinerary_id,
                    createItinerary: this.newPassenger.createItinerary || false,
                    newItineraryName: this.newPassenger.newItineraryName,
                    newItineraryValue: this.newPassenger.newItineraryValue || null,
                };

                const response = await axios.post(`api/v2/trips/${tripId}/passengers`, payload);

                console.log('Resposta da API (adicionar passageiro):', response.data);

                this.$dialog.notify.success("Passageiro adicionado com sucesso à viagem!", { position: 'top-right', timeout: 3000 });
                this.dialogAddPassenger = false;
                await this.load();

            } catch (error) {
                console.error('Erro ao adicionar passageiro:', error);
                let errorMessage = "Erro desconhecido ao adicionar passageiro.";
                if (error.response) {
                    console.error("Dados do erro da API:", error.response.data);
                    if (error.response.data && error.response.data.content.error.message) {
                        errorMessage = error.response.data.content.error.message;
                    } else {
                        errorMessage = `Erro do servidor: ${error.response.status}`;
                    }
                }
                this.$dialog.notify.error(errorMessage, { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }
        },

        async removePassenger(item, itemPassenger) {
            const proceedAction = await this.$dialog.confirm({
                text: `Deseja remover o passageiro <strong>${itemPassenger.passenger.name}</strong> da OS <strong>${item.id}</strong>?`,
                title: 'Remover Passageiro',
                actions: {
                    false: 'Cancelar',
                    true: 'Remover'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true;

            try {
                await axios.delete(`api/v2/trips/${item.id}/passengers/${itemPassenger.passenger.id}`);

                this.$dialog.notify.success(itemPassenger.trip_request_id ? "Passageiro foi removido da viagem e encaminhado de volta para a logística." : "Passageiro removido com sucesso da viagem!", { position: 'top-right', timeout: 3000 });

                await this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }
        },

        createOrUpdateTrip(trip = { status: 1, date: moment().format('YYYY-MM-DD') }) {
            this.dialogTrip = true;

            this.searchVehicle = '';
            this.searchDriver = '';
            this.loadVehicles('');
            this.loadDrivers('');
            this.loadTolls();
            this.loadHolidays();

            this.dataset.data = { ...trip };

            if (this.$refs.tripForm) {
                this.$refs.tripForm.resetValidation();
            }
        },

        async saveTrip() {
            if (!this.$refs.tripForm.validate()) {
                this.$dialog.notify.warning("Por favor, preencha todos os campos obrigatórios corretamente.", { position: 'top-right', timeout: 3000 });
                return;
            }

            // if (!this.dataset.data.vehicle_id) {
            //     this.$dialog.notify.warning("Por favor, selecione um veículo.", { position: 'top-right', timeout: 3000 });
            //     return;
            // }

            if (!this.dataset.data.type) {
                this.$dialog.notify.warning("Por favor, selecione o tipo de viagem.", { position: 'top-right', timeout: 3000 });
                return;
            }

            const inputDate = this.dataset.data.date;
            const inputTime = this.dataset.data.time;

            this.dataList.loading = true;

            try {
                const payload = {
                    vehicle_id: this.dataset.data.vehicle_id,
                    driver_id: this.dataset.data.driver_id,
                    type: this.dataset.data.type,
                    date: inputDate,
                    time: inputTime,
                    status: this.dataset.data.status,
                    toll_id: this.dataset.data.toll_id,
                    holiday_id: this.dataset.data.holiday_id,
                };

                if (this.canViewTripAmounts) {
                    payload.manual_toll_value = this.dataset.data.manual_toll_value !== null
                        && this.dataset.data.manual_toll_value !== undefined
                        && this.dataset.data.manual_toll_value !== ''
                        && !isNaN(parseFloat(this.dataset.data.manual_toll_value))
                        ? parseFloat(this.dataset.data.manual_toll_value)
                        : null;
                    payload.manual_value = !!this.dataset.data.manual_value;
                    payload.value = this.dataset.data.manual_value ? this.dataset.data.value : undefined;
                }

                console.log('Enviando para a API api/v2/trips com o payload:', payload);

                const response = this.dataset.data.id ? await axios.patch(`api/v2/trips/${this.dataset.data.id}`, payload) : await axios.post('api/v2/trips', payload);

                console.log('Resposta da API:', response.data);

                this.$dialog.notify.success("Viagem criada com sucesso!", { position: 'top-right', timeout: 3000 });
                this.dialogTrip = false;

                await this.load();

            } catch (error) {
                console.error('Erro ao criar viagem:', error);
                this.$dialog.notify.error(`Erro ao criar viagem: ${error.toString()}`, { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }
        },

        async updateTripStatus(id, status) {
            if (!status) {
                this.$dialog.notify.warning("Por favor, selecione o novo STATUS para continuar.", { position: 'top-right', timeout: 3000 });
                return;
            }

            this.dataList.loading = true;

            try {

                await axios.patch(`api/v2/trips/${id}`, { status });

                this.$dialog.notify.success("Viagem atualizada com sucesso!", { position: 'top-right', timeout: 3000 });

                await this.load();

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }
        },

        confirmDeleteTrip(item) {
            this.serviceToDelete = item;
            this.dialogConfirmDelete = true;
        },

        normalizeRequesters(item) {
            const uniqueRequesters = Array.from(
                new Map(
                    item.passengers
                        .filter(x => x.requester)
                        .map(x => [x.requester.id, x.requester])
                ).values()
            );

            return uniqueRequesters.length
                ? uniqueRequesters.map(x => x.name).join(', ')
                : 'N/A';
        },

        async openRecalculateDialog() {
            try {
                const response = await axios.get('api/v2/trips/recalculate/status');
                const status = response.data.content;

                if (status.active) {
                    // Ha um recalculo em andamento - mostrar o progresso
                    this.recalculate.processing = true;
                    this.recalculate.finished = false;
                    this.recalculate.total = status.total;
                    this.recalculate.processed = status.processed;
                    this.recalculate.errors = status.errors;
                    this.dialogRecalculate = true;
                    this.startRecalculatePolling();
                    return;
                }
            } catch (error) {
                console.error('Erro ao verificar status de recalculo:', error);
            }

            // Nenhum recalculo em andamento - abrir formulario limpo
            this.recalculate.processing = false;
            this.recalculate.finished = false;
            this.dialogRecalculate = true;
        },

        async confirmRecalculate() {
            if (!this.$refs.recalculateForm.validate()) return;

            this.recalculate.loading = true;

            try {
                const params = {
                    date_start: this.recalculate.date_start,
                    date_end: this.recalculate.date_end,
                };

                if (this.recalculate.id) {
                    params.id = this.recalculate.id;
                }

                if (this.recalculate.customer_id) {
                    params.customer_id = this.recalculate.customer_id;
                }

                const response = await axios.post('api/v2/trips/recalculate', null, { params });
                const result = response.data.content;

                if (result.total === 0) {
                    this.$dialog.notify.info('Nenhuma viagem encontrada para o filtro informado.', { position: 'top-right', timeout: 5000 });
                    this.recalculate.loading = false;
                    return;
                }

                // Inicia modo de acompanhamento
                this.recalculate.loading = false;
                this.recalculate.processing = true;
                this.recalculate.total = result.total;
                this.recalculate.processed = 0;
                this.recalculate.errors = 0;

                this.startRecalculatePolling();
            } catch (error) {
                console.error('Erro ao iniciar recalculo:', error);
                const msg = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Erro ao iniciar recalculo.';
                this.$dialog.notify.error(msg, { position: 'top-right', timeout: 7000 });
                this.recalculate.loading = false;
            }
        },

        startRecalculatePolling() {
            this.stopRecalculatePolling();
            this.recalculatePollingTimer = setInterval(async () => {
                try {
                    const response = await axios.get('api/v2/trips/recalculate/status');
                    const status = response.data.content;

                    this.recalculate.processed = status.processed;
                    this.recalculate.errors = status.errors;
                    this.recalculate.total = status.total;

                    if (status.finished || !status.active) {
                        this.stopRecalculatePolling();
                        this.recalculate.processing = false;
                        this.recalculate.finished = true;
                    }
                } catch (error) {
                    console.error('Erro ao consultar status do recalculo:', error);
                }
            }, 1500);
        },

        stopRecalculatePolling() {
            if (this.recalculatePollingTimer) {
                clearInterval(this.recalculatePollingTimer);
                this.recalculatePollingTimer = null;
            }
        },

        closeRecalculate() {
            this.dialogRecalculate = false;
            this.recalculate.processing = false;
            this.recalculate.finished = false;
            this.recalculate.date_start = '';
            this.recalculate.date_end = '';
            this.recalculate.id = '';
            this.recalculate.customer_id = null;
            this.recalculate.total = 0;
            this.recalculate.processed = 0;
            this.recalculate.errors = 0;
            this.load();
        },

        async deleteTrip() {
            if (!this.serviceToDelete) {
                this.$dialog.notify.error("Nenhum serviço selecionado para exclusão.", { position: 'top-right', timeout: 3000 });
                this.dialogConfirmDelete = false;
                return;
            }

            this.dataList.loading = true;
            this.dialogConfirmDelete = false;

            try {
                const response = await axios.delete(`api/v2/trips/${this.serviceToDelete.id}`);
                if (response.status === 204 || (response.status === 200 && response.data && response.data.status)) {
                    this.$dialog.notify.success("Serviço excluído com sucesso!", { position: 'top-right', timeout: 3000 });
                    await this.load();
                }

            } catch (error) {
                console.error('Erro na exclusão do serviço:', error);
                let errorMessage = "Erro desconhecido ao excluir serviço.";
                if (error.response) {
                    console.error("Dados do erro da API:", error.response.data);
                    if (error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    } else {
                        errorMessage = `Erro do servidor: ${error.response.status}`;
                    }
                }
                this.$dialog.notify.error(`Erro ao excluir serviço: ${errorMessage}`, { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
                this.serviceToDelete = null;
            }
        },


    },
};
</script>

<style>
/* ===== Modal Adicionar/Atualizar Passageiro: formulario + mapa =====
   Bloco global porque os panes do Leaflet nascem em tempo de execucao,
   sem o atributo que o estilo scoped exige. 88vh fica abaixo do teto de
   90% que o Vuetify impoe ao dialog, entao nao ha disputa de altura. */
/* Sem passageiro escolhido o modal fica compacto, como sempre foi; o
   formato grande com mapa so entra quando ha o que mostrar nele. */
.add-pax-modal__form {
    padding: 8px 20px 16px !important;
}

/* Cards por secao, no padrao do modal de solicitacao do cliente */
.add-pax-modal--mapa .add-pax-modal__form {
    background: #f7f9fc;
}

.pax-card {
    background: #fff;
    border: 1px solid #e7ecf3;
    border-radius: 12px;
    padding: 14px 16px 16px;
    box-shadow: 0 1px 4px rgba(16, 34, 64, .05);
    margin-bottom: 14px;
}

.pax-card .pax-secao {
    border-top: none;
    padding-top: 0;
    margin: 0 0 16px;
}

/* Campos mais proximos dentro dos cards */
.pax-card .row {
    margin-top: 0;
    margin-bottom: 0;
}

.pax-card .row [class*="col"] {
    padding-top: 6px;
    padding-bottom: 6px;
}

.pax-card .v-subheader {
    height: 30px;
    padding-left: 0;
}

/* Contadores (0/100) sem empurrar o campo seguinte para longe */
.pax-card .v-text-field__details {
    margin-bottom: 0 !important;
    min-height: 0;
}

.pax-card .v-messages {
    min-height: 0;
}

/* Selecao em linha unica: nome longo nao dobra o campo */
.selecao-linha {
    display: block;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.pax-nowrap .v-select__selections {
    flex-wrap: nowrap;
    overflow: hidden;
}

/* Titulos de secao do formulario, no padrao do modal de solicitacao */
.pax-secao {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 20px 0 8px;
    padding-top: 14px;
    border-top: 1px solid #eef2f7;
}

.pax-secao:first-child {
    margin-top: 4px;
    padding-top: 0;
    border-top: none;
}

.pax-secao > span {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #e8f0fe;
    color: #1450b5;
    font-weight: 700;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
}

.pax-secao strong {
    display: block;
    font-size: 14px;
    color: #1f2a44;
    line-height: 1.2;
}

.pax-secao small {
    color: #8a94a6;
    font-size: 12px;
}

/* Especificidade alta + !important: em dev a ordem de injecao do CSS
   muda e a cadeia de altura perdia para as regras do Vuetify - mesmo
   problema ja enfrentado no modal de solicitacao do painel do cliente. */
.v-card.add-pax-modal--mapa {
    height: min(840px, 88vh) !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
}

.add-pax-modal--mapa .add-pax-modal__body {
    display: flex !important;
    flex: 1 1 auto !important;
    min-height: 0 !important;
}

.add-pax-modal--mapa .v-card__text.add-pax-modal__form {
    flex: 0 0 480px !important;
    max-width: 480px !important;
    min-height: 0 !important;
    overflow-y: auto !important;
}

.add-pax-modal__mapa {
    flex: 1 1 auto;
    position: relative;
    min-width: 0;
    border-left: 1px solid #eef2f7;
}

.add-pax-modal__canvas {
    position: absolute;
    inset: 0;
    z-index: 0;
    cursor: crosshair;
}

/* Visual claro estilo "Positron", igual aos demais mapas do sistema */
.add-pax-modal__canvas .leaflet-tile-pane {
    filter: grayscale(100%) brightness(104%) contrast(88%);
}

.add-pax-modal__actions {
    flex: 0 0 auto !important;
    border-top: 1px solid #eef2f7;
    padding: 10px 20px !important;
}

/* Mesmo pin do modal de solicitacao do painel do cliente */
.add-pax-modal__icone {
    cursor: grab;
    background: transparent;
    border: none;
}

.add-pax-pin {
    width: 30px;
    height: 30px;
    border-radius: 50% 50% 50% 0;
    transform: rotate(-45deg);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
}

.add-pax-pin span {
    transform: rotate(45deg);
    color: #fff;
    font-size: 13px;
    font-weight: 600;
}

.add-pax-pin--origem { background: #1450b5; }
.add-pax-pin--destino { background: #0f9d66; }

.add-pax-flutuante {
    position: absolute;
    left: 12px;
    right: 12px;
    z-index: 500;
    display: flex;
    gap: 8px;
    align-items: flex-start;
    pointer-events: none;
}

.add-pax-flutuante--topo { top: 12px; }
.add-pax-flutuante--base { bottom: 12px; right: 72px; }

.add-pax-flutuante > * { pointer-events: auto; }

.add-pax-abas {
    display: flex;
    gap: 4px;
    background: #fff;
    border-radius: 10px;
    padding: 4px;
    box-shadow: 0 2px 10px rgba(16, 34, 64, .14);
}

.add-pax-aba {
    display: flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: transparent;
    border-radius: 8px;
    padding: 6px 10px;
    font-size: 12.5px;
    cursor: pointer;
    color: #41506b;
}

.add-pax-aba.is-ativa {
    background: #e8f0fe;
    color: #1450b5;
    font-weight: 600;
}

.add-pax-bolinha {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
    flex: 0 0 auto;
}

.add-pax-bolinha--origin { background: #1450b5; }
.add-pax-bolinha--destination { background: #0f9d66; }

.add-pax-cartao {
    background: #fff;
    border-radius: 10px;
    padding: 10px 12px;
    box-shadow: 0 2px 10px rgba(16, 34, 64, .14);
    font-size: 12.5px;
    color: #41506b;
    max-width: 100%;
}

.add-pax-dica { flex: 1 1 auto; }

.add-pax-buscar {
    flex: 0 0 auto;
    background: #fff;
}

.add-pax-flutuante--base .add-pax-cartao { flex: 1 1 auto; min-width: 0; }

.add-pax-linha {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.add-pax-linha + .add-pax-linha { margin-top: 6px; }

.add-pax-linha .add-pax-bolinha { margin-top: 4px; }

.add-pax-texto {
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.add-pax-texto strong {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.add-pax-texto small { color: #8a94a6; }

.add-pax-rota {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #eef2f7;
    font-weight: 600;
    color: #1450b5;
    display: flex;
    align-items: center;
    gap: 4px;
}

/* Em telas estreitas o mapa vai para baixo do formulario e o card
   inteiro rola (altura auto anula o flex, entao o scroll e do card) */
@media (max-width: 960px) {
    .v-card.add-pax-modal--mapa { height: auto !important; max-height: 88vh !important; overflow-y: auto !important; }
    .add-pax-modal--mapa .add-pax-modal__body { flex-direction: column !important; }
    .add-pax-modal--mapa .v-card__text.add-pax-modal__form { flex: 0 0 auto !important; max-width: none !important; overflow-y: visible !important; }
    .add-pax-modal__mapa { min-height: 300px; border-left: none; border-top: 1px solid #eef2f7; }
}
</style>

<style scoped>
/* Agrupa pedagio e total manual num bloco proprio: soltos no formulario, os
   dois campos e suas dicas competiam com os dados basicos da viagem. */
.os-link {
    color: inherit !important;
    text-decoration: underline dotted;
    cursor: pointer;
}

.values-section {
    background: #fafafa;
    border: 1px solid rgba(0, 0, 0, .09);
    border-radius: 6px;
    padding: 14px 16px 16px;
}

.values-title {
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    color: #2c3153;
    margin-bottom: 2px;
}

.values-hint {
    font-size: 12px;
    line-height: 1.4;
    color: rgba(0, 0, 0, .55);
    margin: 0 0 10px;
}

/* Previa do valor: o operador precisa ver quanto vai ficar antes de salvar */
.value-preview {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, .09);
    border-radius: 5px;
    padding: 10px 14px;
    margin-top: 8px;
}

.value-preview-label {
    font-size: 12px;
    color: rgba(0, 0, 0, .6);
}

.value-preview-amount {
    font-size: 20px;
    font-weight: 600;
    color: #2c3153;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.value-preview-amount.is-manual {
    color: #b45309;
}

.border-error {
    border: 1px solid var(--v-error-base);
}

.table-header-row,
.service-row {
    gap: 12px;
    /* Espaço entre as colunas */
}

/* Cabeçalho e linhas com as mesmas larguras (as colunas do Vuetify são .col) */
.table-header-row > .col,
.service-row > .col {
    padding: 0 !important;
}

.table-header-row {
    font-size: 11px;
    letter-spacing: 0.04em;
    color: #52627d;
}

.service-col-icon {
    min-width: 28px;
    max-width: 28px;
}

.header-col-os,
.service-col-os {
    min-width: 90px;
    max-width: 90px;
    white-space: nowrap;
}

.header-col-datetime,
.service-col-datetime {
    min-width: 100px;
    max-width: 100px;
}

.header-col-itinerary,
.service-col-itinerary {
    min-width: 160px;
}

/* Itinerário em até 2 linhas; o texto completo fica no title */
.service-col-itinerary {
    text-align: left;
}

.service-col-itinerary .route-itinerary {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.header-col-requester,
.service-col-driver {
    min-width: 120px;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.header-col-vehicle,
.service-col-vehicle {
    min-width: 100px;
    max-width: 100px;
}

.header-col-status,
.service-col-status {
    min-width: 110px;
    max-width: 110px;
}

/* Ações sempre em uma linha */
.header-col-actions,
.service-col-actions {
    min-width: 150px;
    max-width: 150px;
}

.service-col-actions {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    white-space: nowrap;
}

/* Lista de OS num cartão só: cabeçalho no topo e cada OS como uma linha */
.list-container-card {
    overflow: hidden;
}

.list-container-card > .table-header-row {
    margin: 0 !important;
    padding: 12px 16px !important;
    background: #f7f8fb;
    border-bottom: 1px solid var(--v-border-base);
}

.list-container-card > .row:not(.table-header-row) {
    margin: 0 !important;
}

.list-container-card > .row:not(.table-header-row) > .col {
    padding: 0 !important;
}

.list-container-card > .row:not(.table-header-row) > .col > .v-card {
    border: 0 !important;
    border-bottom: 1px solid var(--v-border-base) !important;
    border-radius: 0 !important;
    box-shadow: none !important;
}

.list-container-card > .row:not(.table-header-row) > .col > .v-card:hover {
    background: #fafcff;
}

/* Desabilita todos os eventos do mouse no expansível */
.non-clickable-header {
    pointer-events: none;
    cursor: default;
}

.icon-container {
    display: flex;
    align-items: center;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 8px;
}

.cancellation-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
}

.cancellation-toolbar .v-input {
    max-width: 260px;
}

.cancellation-reason {
    min-width: 220px;
    max-width: 360px;
    white-space: normal;
    line-height: 1.35;
}

.cancellation-review-summary {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    padding: 16px;
    border: 1px solid #e0e4ea;
    border-radius: 6px;
    background: #f8fafc;
}

.cancellation-review-summary > div {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.cancellation-review-summary span {
    color: #6b7280;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
}

.cancellation-review-summary .full {
    grid-column: 1 / -1;
}

.trip-history-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.trip-history-timeline {
    padding-top: 12px;
}

.trip-history-event {
    padding-bottom: 8px;
}

.trip-history-event-title {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}

.trip-history-event-title span {
    color: #6b7280;
    flex-shrink: 0;
    font-size: 12px;
}

.trip-history-event-description {
    color: #4b5563;
    font-size: 13px;
    line-height: 1.4;
    margin-top: 4px;
}

.trip-history-event-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
}

.trip-history-details-header {
    font-size: 13px;
    min-height: 36px;
    padding: 8px 0;
}

.trip-history-change-table {
    border: 1px solid #edf0f4;
}

@media (max-width: 600px) {
    .cancellation-toolbar {
        align-items: stretch;
        flex-direction: column;
    }

    .cancellation-toolbar .v-input {
        max-width: none;
    }

    .cancellation-review-summary {
        grid-template-columns: 1fr;
    }

    .cancellation-review-summary .full {
        grid-column: auto;
    }

    .trip-history-event-title {
        flex-direction: column;
        gap: 2px;
    }
}
</style>
